const REGIONS = [
  "Central Region",
  "Eastern Region",
  "Western Region",
  "Northern Region",
  "Southern Region",
  "Industrial Zone",
  "Corporate Region",
];

const DEPARTMENTS = [
  "HSE",
  "Operations",
  "Maintenance",
  "QA/QC",
  "Logistics",
  "Security",
  "Administration",
  "HR",
  "Facilities",
  "Training",
];

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const SITE_OBJECTS = [
  { id: "SITE-001", number: "Marvin HSSE Dashboard", name: "Marvin HSSE Dashboard", code: "MHD", region: "Corporate Region", location: "Personal reporting workspace", latitude: 0, longitude: 0, manager: "Marvin", contact: "marvin.hsse@example.com", status: "Active" },
  { id: "SITE-002", number: "Rig Operations", name: "Rig Operations", code: "RIG", region: "Industrial Zone", location: "Rig site", latitude: 0, longitude: 0, manager: "Marvin", contact: "marvin.hsse@example.com", status: "Active" },
  { id: "SITE-003", number: "Maintenance Area", name: "Maintenance Area", code: "MNT", region: "Central Region", location: "Maintenance and inspection area", latitude: 0, longitude: 0, manager: "Marvin", contact: "marvin.hsse@example.com", status: "Active" },
  { id: "SITE-004", number: "Camp and Galley", name: "Camp and Galley", code: "CAG", region: "Western Region", location: "Camp, galley and welfare area", latitude: 0, longitude: 0, manager: "Marvin", contact: "marvin.hsse@example.com", status: "Active" },
].map((site) => ({
  ...site,
  createdDate: "2026-01-01",
  updatedDate: "2026-05-25",
}));

const SITE_NAMES = SITE_OBJECTS.map((s) => s.number);

const KPI_ROWS = [
  { key: "tbt", name: "Pre-Job / Toolbox Meetings", group: "leading" },
  { key: "hocCards", name: "HOC Cards / Safety Intervention Program", group: "leading" },
  { key: "inducted", name: "Safety Induction", group: "leading" },
  { key: "dailyCraneInspection", name: "Daily Crane Inspection", group: "inspection" },
  { key: "weeklyCraneInspection", name: "Weekly Crane Inspection", group: "inspection" },
  { key: "firePumpInspection", name: "Fire Pump Inspection & Testing", group: "inspection" },
  { key: "ppeInspection", name: "PPE Inspection", group: "inspection" },
  { key: "liftingGearInspection", name: "Lifting Gear Inspection", group: "inspection" },
  { key: "rigInspection", name: "Rig Inspection", group: "inspection" },
  { key: "pestControl", name: "Pest Control", group: "inspection" },
  { key: "drills", name: "Emergency Drills", group: "leading" },
  { key: "awards", name: "HSSE Award", group: "leading" },
  { key: "followUpAudit", name: "Follow-up Audit / Inspection", group: "audit" },
  { key: "nearMiss", name: "Near Miss", group: "lagging" },
  { key: "fac", name: "First Aid", group: "lagging" },
  { key: "lti", name: "LTI", group: "lagging" },
  { key: "mtc", name: "MTC", group: "lagging" },
  { key: "propertyDamage", name: "Property Damage", group: "lagging" },
  { key: "manpower", name: "Total Manpower", group: "people" },
  { key: "manhours", name: "Total Manhours", group: "people" },
  { key: "workdaysLost", name: "No of Workdays lost", group: "incident" },
  { key: "training", name: "No of Training (Inhouse, induction, specific)", group: "training" },
  { key: "extTraining", name: "No of External Training", group: "training" },
  { key: "incidents", name: "No of Incident/accident", group: "incident" },
  { key: "violations", name: "No of Violations Issued", group: "compliance" },
  { key: "obsRaised", name: "No of Site Observation Raised", group: "obs" },
  { key: "obsClosed", name: "No of Site Observation CLOSED", group: "obs" },
  { key: "sorReceived", name: "No of SOR Received", group: "obs" },
  { key: "sorOpen", name: "No of SOR Open", group: "obs" },
  { key: "sorClosed", name: "No of SOR Closed", group: "obs" },
  { key: "ncrReceived", name: "No of NCR received", group: "ncr" },
  { key: "ncrClosed", name: "No of NCR Closed", group: "ncr" },
  { key: "ncrOpen", name: "No of NCR Open", group: "ncr" },
  { key: "fines", name: "Authority Fines if any", group: "compliance" },
  { key: "wasteGen", name: "Waste Generated Tonnes", group: "env" },
  { key: "wasteRec", name: "Waste recycled tonnes", group: "env" },
  { key: "mom", name: "MOM", group: "compliance" },
  { key: "inspections", name: "No of Monthly inspection (tools, equipments)", group: "audit" },
  { key: "internalAudit", name: "No of Internal Audits", group: "audit" },
  { key: "externalAudit", name: "No of External Audits", group: "audit" },
];

const SITE_KPI = Object.fromEntries(SITE_NAMES.map((name) => [name, {
  manpower: 0,
  manhours: 0,
  fac: 0,
  mtc: 0,
  lti: 0,
  incidents: 0,
  nearMiss: 0,
  propertyDamage: 0,
  obsRaised: 0,
  obsClosed: 0,
  training: 0,
  inducted: 0,
  inspections: 0,
  wasteGen: 0,
  wasteRec: 0
}]));

function trend(base, variance = 0.08, decimals = 0) {
  return MONTHS.map((_, i) => {
    const seasonal = 1 + Math.sin((i + 1) / 2.2) * variance + (i > 7 ? 0.035 : 0);
    const value = base * seasonal;
    return decimals ? +value.toFixed(decimals) : Math.round(value);
  });
}

function monthlyCounts(total, months) {
  const arr = MONTHS.map(() => 0);
  if (!total || total <= 0) return arr;
  for (let i = 0; i < total; i += 1) {
    const idx = months[i % months.length] ?? i % 12;
    arr[idx] += 1;
  }
  return arr;
}

function generateMarvinKPI() {
  const zero = () => Array(12).fill(0);
  const data = {};

  SITE_NAMES.forEach((site) => {
    data[site] = {};
    KPI_ROWS.forEach((row) => {
      data[site][row.key] = zero();
    });
  });

  const marvinSite = SITE_NAMES[0];

  if (data[marvinSite]) {
    const set = (key, values) => {
      data[marvinSite][key] = [
        values[0] || 0,
        values[1] || 0,
        values[2] || 0,
        values[3] || 0,
        0, 0, 0, 0, 0, 0, 0, 0
      ];
    };

    // Confirmed dashboard period: Jan-April only. May-Dec intentionally kept 0.
    set("tbt", [4, 4, 62, 302]);
    set("hocCards", [3945, 2897, 3276, 3381]);
    set("inducted", [0, 0, 19, 35]);
    set("dailyCraneInspection", [0, 0, 31, 30]);
    set("weeklyCraneInspection", [0, 0, 4, 4]);
    set("firePumpInspection", [0, 0, 4, 4]);
    set("ppeInspection", [0, 0, 1, 1]);
    set("liftingGearInspection", [0, 0, 1, 1]);
    set("rigInspection", [0, 0, 4, 4]);
    set("pestControl", [0, 0, 2, 2]);
    set("drills", [1, 0, 3, 5]);
    set("awards", [2, 0, 4, 4]);
    set("followUpAudit", [1, 1, 1, 1]);

    set("nearMiss", [0, 0, 0, 0]);
    set("fac", [0, 0, 0, 0]);
    set("lti", [0, 0, 0, 0]);
    set("mtc", [0, 0, 0, 0]);
    set("propertyDamage", [0, 0, 0, 0]);
    set("incidents", [0, 0, 0, 0]);
    set("violations", [0, 0, 0, 0]);
  }

  return data;
}

const LEGAL_REFS = [
  { id: "LR-001", title: "OSHA 1910.132 - PPE General Requirements", regulation: "OSHA 29 CFR", clause: "1910.132", description: "Employers must provide proper PPE.", module: "All", status: "Active" },
  { id: "LR-002", title: "OSHA 1910.146 - Permit-Required Confined Spaces", regulation: "OSHA 29 CFR", clause: "1910.146", description: "Confined space entry permits.", module: "Inspection", status: "Active" },
  { id: "LR-003", title: "OSHA 1910.147 - Lockout/Tagout", regulation: "OSHA 29 CFR", clause: "1910.147", description: "Control of hazardous energy.", module: "Inspection", status: "Active" },
  { id: "LR-004", title: "ISO 45001 Clause 6.1.2 - Hazard Identification", regulation: "ISO 45001:2018", clause: "6.1.2", description: "Hazard identification and risk assessment.", module: "Action Plan", status: "Active" },
  { id: "LR-005", title: "ISO 45001 Clause 8.1.2 - Eliminating Hazards", regulation: "ISO 45001:2018", clause: "8.1.2", description: "Hierarchy of controls.", module: "Action Plan", status: "Active" },
  { id: "LR-006", title: "ISO 14001 Clause 6.1.2 - Environmental Aspects", regulation: "ISO 14001:2015", clause: "6.1.2", description: "Significant environmental aspects.", module: "NCR", status: "Active" },
  { id: "LR-007", title: "OSHA 1926.501 - Fall Protection", regulation: "OSHA 29 CFR", clause: "1926.501", description: "Fall protection requirements.", module: "Inspection", status: "Active" },
  { id: "LR-008", title: "NFPA 70E - Electrical Safety", regulation: "NFPA 70E", clause: "120.1", description: "Electrical safe work practices.", module: "Inspection", status: "Active" },
];

const incidents = [];

const observations = [
  {
    "id": "OBS-2026-001",
    "sorId": "MVT-2026-001",
    "date": "2026-01-28",
    "site": "ZHONGYOUHAI-16",
    "department": "Electrical",
    "type": "Management Visit",
    "category": "Helideck Safety",
    "raisedBy": "Project Manager Visit",
    "responsible": "Chief Electrician",
    "dueDate": "2026-02-03",
    "status": "Closed",
    "description": "One helideck perimeter light earthing cable found disconnected.",
    "action": "Reinstate and verify proper earthing for helideck boundary lights and conduct functional checks."
  },
  {
    "id": "OBS-2026-002",
    "sorId": "MVT-2026-002",
    "date": "2026-01-28",
    "site": "ZHONGYOUHAI-16",
    "department": "Electrical",
    "type": "Management Visit",
    "category": "Dropped Object Prevention",
    "raisedBy": "Project Manager Visit",
    "responsible": "Chief Electrician",
    "dueDate": "2026-02-03",
    "status": "Closed",
    "description": "Anti-drop safety net for light fittings on accommodation roof not installed as per standard.",
    "action": "Install or rectify anti-drop safety nets for light fittings in accordance with applicable standards."
  },
  {
    "id": "OBS-2026-003",
    "sorId": "MVT-2026-003",
    "date": "2026-01-28",
    "site": "ZHONGYOUHAI-16",
    "department": "Marine / Deck",
    "type": "Management Visit",
    "category": "Fire Safety",
    "raisedBy": "Project Manager Visit",
    "responsible": "Bargemaster",
    "dueDate": "2026-02-03",
    "status": "Open",
    "description": "One fire hydrant blind cap safety chain found broken on main deck.",
    "action": "Replace damaged fire hydrant blind cap safety chain and inspect similar fittings for integrity."
  },
  {
    "id": "OBS-2026-004",
    "sorId": "MVT-2026-004",
    "date": "2026-01-28",
    "site": "ZHONGYOUHAI-16",
    "department": "Engineering",
    "type": "Management Visit",
    "category": "Housekeeping",
    "raisedBy": "Project Manager Visit",
    "responsible": "Chief Engineer",
    "dueDate": "2026-02-03",
    "status": "Closed",
    "description": "Unnecessary materials observed in emergency generator room.",
    "action": "Remove all non-essential items from emergency generator room and reinforce housekeeping controls."
  },
  {
    "id": "OBS-2026-005",
    "sorId": "MVT-2026-005",
    "date": "2026-01-28",
    "site": "ZHONGYOUHAI-16",
    "department": "Lifting Operations",
    "type": "Management Visit",
    "category": "Certification / Inspection",
    "raisedBy": "Project Manager Visit",
    "responsible": "Bargemaster",
    "dueDate": "2026-02-03",
    "status": "Open",
    "description": "Man-riding basket inspection approaching expiry date.",
    "action": "Arrange inspection and re-certification of man-riding basket before inspection expiry date."
  },
  {
    "id": "OBS-2026-FEB-HK-014",
    "sorId": "HK-FEB-2026-001",
    "date": "2026-02-26",
    "site": "ZHONGYOUHAI-16",
    "department": "Housekeeping / Deck",
    "type": "Housekeeping Audit",
    "category": "Trip Hazard / Hose Management",
    "raisedBy": "Cecep / Mahfud",
    "responsible": "ANDRE / DANI",
    "dueDate": "2026-03-05",
    "status": "Open",
    "description": "Area clear; small hose laying on ground. Score: 75%",
    "action": "Protect or remove hose from walkway and maintain clear access route."
  },
  {
    "id": "OBS-2026-FEB-HK-015",
    "sorId": "HK-FEB-2026-002",
    "date": "2026-02-26",
    "site": "ZHONGYOUHAI-16",
    "department": "Housekeeping / Deck",
    "type": "Housekeeping Audit",
    "category": "Trip Hazard / Hose Management",
    "raisedBy": "Cecep / Mahfud",
    "responsible": "ANDRE / DANI",
    "dueDate": "2026-03-05",
    "status": "Open",
    "description": "Area clear; small hose laying on ground. Score: 75%",
    "action": "Protect or remove hose from walkway and maintain clear access route."
  },
  {
    "id": "OBS-2026-MAR-HK-009",
    "sorId": "HK-MAR-2026-001",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "department": "Housekeeping / Below Deck",
    "type": "Housekeeping Audit",
    "category": "Housekeeping / Cleanliness",
    "raisedBy": "Irwin / Armand",
    "responsible": "ANDRE / DANI",
    "dueDate": "2026-03-31",
    "status": "Open",
    "description": "Working floor is dirty and requires immediate cleaning. Good housekeeping must be maintained to ensure safety. Score: 75%",
    "action": "Clean Upper Sack Room working floor immediately and maintain good housekeeping condition."
  },
  {
    "id": "OBS-2026-MAR-CERMAT-001",
    "sorId": "CERMAT-MAR-2026-001",
    "date": "2026-03-24",
    "site": "ZHONGYOUHAI-16",
    "department": "Lifting Operations",
    "type": "CeRMAT / Safety Observation",
    "category": "Personnel Basket / Secondary Sling",
    "raisedBy": "Ardiansyah - Crane Operator",
    "responsible": "Lifting Team",
    "dueDate": "2026-03-24",
    "status": "Closed",
    "description": "Secondary sling on personnel basket was connected using only a knot.",
    "action": "Removed and reconnected properly using a shackle."
  },
  {
    "id": "OBS-2026-MAR-PERWIRA-001",
    "sorId": "PERWIRA-MAR-2026-001",
    "date": "2026-03-31",
    "site": "ZHONGYOUHAI-16",
    "department": "Safety Leadership / Recognition",
    "type": "Positive Safety Recognition",
    "category": "Best Perwira Safety",
    "raisedBy": "HSE Team",
    "responsible": "M RIKY - Floorman",
    "dueDate": "2026-03-31",
    "status": "Closed",
    "description": "M RIKY selected as Best Perwira Safety of the Month for active participation in pre-job safety meetings, speak up, view & review, BSOC card submission, fire watch duties, and CLSR implementation.",
    "action": "Recognized as Best Perwira Safety of the Month."
  },
  {
    "id": "OBS-2026-APR-CERMAT-001",
    "sorId": "CERMAT-APR-2026-001",
    "date": "2026-04-19",
    "site": "ZHONGYOUHAI-16",
    "department": "Rig Move / Skidding",
    "type": "CeRMAT / Safety Observation",
    "category": "Cable Entanglement / Line of Fire",
    "raisedBy": "Muhammad Riky - Floorman",
    "responsible": "Rig Crew",
    "dueDate": "2026-04-19",
    "status": "Closed",
    "description": "During skidding rig, observed cable might be stuck / entangled on beam and could break.",
    "action": "Immediately rolled out cable from stuck area."
  },
  {
    "id": "OBS-2026-APR-PERWIRA-001",
    "sorId": "PERWIRA-APR-2026-001",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "department": "Safety Leadership / Recognition",
    "type": "Positive Safety Recognition",
    "category": "Best Perwira Safety",
    "raisedBy": "HSE Team",
    "responsible": "Dava Hariatmaja - Cutting Dryer Operator",
    "dueDate": "2026-04-30",
    "status": "Closed",
    "description": "Dava Hariatmaja selected as Best Perwira Safety of the Month for LOTO/pinch point control, intervention on missing ear protection during chipping/buffing, BSOC card submission, and CLSR implementation.",
    "action": "Recognized as Best Perwira Safety of the Month."
  },
  {
    "id": "OBS-2026-JAN-CERMAT-001",
    "sorId": "CERMAT-JAN-2026-001",
    "date": "2026-01-25",
    "site": "ZHONGYOUHAI-16",
    "department": "Lifting Operations",
    "type": "CeRMAT / Safety Observation",
    "category": "Dropped Object Prevention",
    "raisedBy": "Leman Junaidi - Rostabout",
    "responsible": "Rig Crew",
    "dueDate": "2026-01-25",
    "status": "Closed",
    "description": "During cutting dryer lifting preparation, scrap material was identified underneath with potential dropped object risk.",
    "action": "Scrap material removed and lifting operation continued safely."
  },
  {
    "id": "OBS-2026-JAN-PERWIRA-001",
    "sorId": "PERWIRA-JAN-2026-001",
    "date": "2026-01-31",
    "site": "ZHONGYOUHAI-16",
    "department": "Safety Leadership / Recognition",
    "type": "Positive Safety Recognition",
    "category": "Best Perwira Safety",
    "raisedBy": "HSE Team",
    "responsible": "Zaini Dahlan - Floorman",
    "dueDate": "2026-01-31",
    "status": "Closed",
    "description": "Zaini Dahlan selected as Best Perwira Safety for promoting line-of-fire awareness, hands-free lifting policy, PHM CLSR, and stop work authority.",
    "action": "Recognized as Best Perwira Safety."
  }
];

const inspections = [
  {
    "id": "INSP-2025-010",
    "date": "2025-10-29",
    "site": "ZHONGYOUHAI-16",
    "area": "Wellhead WPS 4",
    "type": "Housekeeping",
    "inspector": "Ali Rizki / Mahfud Ridwan",
    "obsRefId": "",
    "findings": "Observed clean. Score: 100%.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain condition.",
    "responsible": "Area Supervisor",
    "dueDate": "2025-10-29",
    "status": "Closed",
    "completionDate": "2025-10-29",
    "remarks": "Source: Housekeeping Report October 2025."
  },
  {
    "id": "INSP-2025-011",
    "date": "2025-10-29",
    "site": "ZHONGYOUHAI-16",
    "area": "Cellar Deck WPS 4",
    "type": "Housekeeping",
    "inspector": "Ali Rizki / Mahfud Ridwan",
    "obsRefId": "",
    "findings": "Observed clean. Score: 100%.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain condition.",
    "responsible": "Area Supervisor",
    "dueDate": "2025-10-29",
    "status": "Closed",
    "completionDate": "2025-10-29",
    "remarks": "Source: Housekeeping Report October 2025."
  },
  {
    "id": "INSP-2025-012",
    "date": "2025-10-29",
    "site": "ZHONGYOUHAI-16",
    "area": "Boat Landing Structure WPS 4",
    "type": "Housekeeping",
    "inspector": "Ali Rizki / Mahfud Ridwan",
    "obsRefId": "",
    "findings": "Observed clean; some spot cannot be cleaned. Score: 75%.",
    "risk": "Medium",
    "legalRef": "",
    "correctiveAction": "Review difficult-to-clean spot and improve housekeeping/tidiness where practicable.",
    "responsible": "Area Supervisor",
    "dueDate": "2025-11-05",
    "status": "In Progress",
    "completionDate": "",
    "remarks": "Keep up and improve housekeeping & tidiness. Source: Housekeeping Report October 2025."
  },
  {
    "id": "INSP-2026-HK-001",
    "date": "2026-02-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Engine Room - Below Deck",
    "type": "Housekeeping / Fire Equipment",
    "inspector": "Cecep / Mahfud",
    "obsRefId": "",
    "findings": "Walkway clear; emergency firefighting equipment inspected and ready for use. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "ANDRE / DANI",
    "dueDate": "2026-02-26",
    "status": "Closed",
    "completionDate": "2026-02-26",
    "remarks": "Source: Housekeeping Report February 2026."
  },
  {
    "id": "INSP-2026-HK-002",
    "date": "2026-02-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Compressor Room - Below Deck",
    "type": "Housekeeping / Emergency Route",
    "inspector": "Cecep / Mahfud",
    "obsRefId": "",
    "findings": "Walkway clear; emergency route marking sighted. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "ANDRE / DANI",
    "dueDate": "2026-02-26",
    "status": "Closed",
    "completionDate": "2026-02-26",
    "remarks": "Source: Housekeeping Report February 2026."
  },
  {
    "id": "INSP-2026-HK-003",
    "date": "2026-02-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Motorman Workshop - Below Deck",
    "type": "Housekeeping / Tool Control",
    "inspector": "Cecep / Mahfud",
    "obsRefId": "",
    "findings": "Walkway clear; tools and equipment tidy. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "ANDRE / DANI",
    "dueDate": "2026-02-26",
    "status": "Closed",
    "completionDate": "2026-02-26",
    "remarks": "Source: Housekeeping Report February 2026."
  },
  {
    "id": "INSP-2026-HK-004",
    "date": "2026-02-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Mud Pit - Below Deck",
    "type": "Housekeeping / Spill Prevention",
    "inspector": "Cecep / Mahfud",
    "obsRefId": "",
    "findings": "Walkway clear and dry; no spillage observed. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "ANDRE / DANI",
    "dueDate": "2026-02-26",
    "status": "Closed",
    "completionDate": "2026-02-26",
    "remarks": "Source: Housekeeping Report February 2026."
  },
  {
    "id": "INSP-2026-HK-005",
    "date": "2026-02-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Mud Pump Mezzanine - Below Deck",
    "type": "Housekeeping / Emergency Route",
    "inspector": "Cecep / Mahfud",
    "obsRefId": "",
    "findings": "Area clean; walkway clear; emergency route signage sighted. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "ANDRE / DANI",
    "dueDate": "2026-02-26",
    "status": "Closed",
    "completionDate": "2026-02-26",
    "remarks": "Source: Housekeeping Report February 2026."
  },
  {
    "id": "INSP-2026-HK-006",
    "date": "2026-02-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Mud Pump Main Walkway",
    "type": "Housekeeping / Housekeeping",
    "inspector": "Cecep / Mahfud",
    "obsRefId": "",
    "findings": "Walkway clean and dry. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "ANDRE / DANI",
    "dueDate": "2026-02-26",
    "status": "Closed",
    "completionDate": "2026-02-26",
    "remarks": "Source: Housekeeping Report February 2026."
  },
  {
    "id": "INSP-2026-HK-007",
    "date": "2026-02-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Lower Sack Room",
    "type": "Housekeeping / Escape Route",
    "inspector": "Cecep / Mahfud",
    "obsRefId": "",
    "findings": "Working floor clean and dry; no blockage on escape route. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "ANDRE / DANI",
    "dueDate": "2026-02-26",
    "status": "Closed",
    "completionDate": "2026-02-26",
    "remarks": "Source: Housekeeping Report February 2026."
  },
  {
    "id": "INSP-2026-HK-008",
    "date": "2026-02-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Lower Sack Room - Escape Route",
    "type": "Housekeeping / Repainting",
    "inspector": "Cecep / Mahfud",
    "obsRefId": "",
    "findings": "Escape route visible and clean; some floor areas require repainting. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "ANDRE / DANI",
    "dueDate": "2026-02-26",
    "status": "Closed",
    "completionDate": "2026-02-26",
    "remarks": "Source: Housekeeping Report February 2026."
  },
  {
    "id": "INSP-2026-HK-009",
    "date": "2026-02-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Upper Sack Room",
    "type": "Housekeeping / Walkway Marking",
    "inspector": "Cecep / Mahfud",
    "obsRefId": "",
    "findings": "Floor slightly dirty and walkway markings faded; recorded as 100%.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "ANDRE / DANI",
    "dueDate": "2026-02-26",
    "status": "Closed",
    "completionDate": "2026-02-26",
    "remarks": "Source: Housekeeping Report February 2026."
  },
  {
    "id": "INSP-2026-HK-010",
    "date": "2026-02-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Main Deck - Portside",
    "type": "Housekeeping / Housekeeping",
    "inspector": "Cecep / Mahfud",
    "obsRefId": "",
    "findings": "Walkway clean and dry. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "ANDRE / DANI",
    "dueDate": "2026-02-26",
    "status": "Closed",
    "completionDate": "2026-02-26",
    "remarks": "Source: Housekeeping Report February 2026."
  },
  {
    "id": "INSP-2026-HK-011",
    "date": "2026-02-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Main Deck - Loading Hatch",
    "type": "Housekeeping / Emergency Route",
    "inspector": "Cecep / Mahfud",
    "obsRefId": "",
    "findings": "Area clear; emergency route free from obstruction. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "ANDRE / DANI",
    "dueDate": "2026-02-26",
    "status": "Closed",
    "completionDate": "2026-02-26",
    "remarks": "Source: Housekeeping Report February 2026."
  },
  {
    "id": "INSP-2026-HK-012",
    "date": "2026-02-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Main Deck - Bosun Store",
    "type": "Housekeeping / Emergency Route",
    "inspector": "Cecep / Mahfud",
    "obsRefId": "",
    "findings": "Area clear; emergency route signage sighted. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "ANDRE / DANI",
    "dueDate": "2026-02-26",
    "status": "Closed",
    "completionDate": "2026-02-26",
    "remarks": "Source: Housekeeping Report February 2026."
  },
  {
    "id": "INSP-2026-HK-013",
    "date": "2026-02-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Main Deck - Center Walkway",
    "type": "Housekeeping / Emergency Route",
    "inspector": "Cecep / Mahfud",
    "obsRefId": "",
    "findings": "Area clear; emergency route signage sighted. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "ANDRE / DANI",
    "dueDate": "2026-02-26",
    "status": "Closed",
    "completionDate": "2026-02-26",
    "remarks": "Source: Housekeeping Report February 2026."
  },
  {
    "id": "INSP-2026-HK-014",
    "date": "2026-02-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Main Deck - Welding Shop STBD",
    "type": "Housekeeping / Trip Hazard",
    "inspector": "Cecep / Mahfud",
    "obsRefId": "OBS-2026-FEB-HK-014",
    "findings": "Area clear; small hose laying on ground. Score: 75%",
    "risk": "Medium",
    "legalRef": "",
    "correctiveAction": "Protect or remove hose from walkway and maintain clear access route.",
    "responsible": "ANDRE / DANI",
    "dueDate": "2026-03-05",
    "status": "In Progress",
    "completionDate": "",
    "remarks": "Source: Housekeeping Report February 2026."
  },
  {
    "id": "INSP-2026-HK-015",
    "date": "2026-02-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Main Deck - Cantilever Access STBD",
    "type": "Housekeeping / Trip Hazard",
    "inspector": "Cecep / Mahfud",
    "obsRefId": "OBS-2026-FEB-HK-015",
    "findings": "Area clear; small hose laying on ground. Score: 75%",
    "risk": "Medium",
    "legalRef": "",
    "correctiveAction": "Protect or remove hose from walkway and maintain clear access route.",
    "responsible": "ANDRE / DANI",
    "dueDate": "2026-03-05",
    "status": "In Progress",
    "completionDate": "",
    "remarks": "Source: Housekeeping Report February 2026."
  },
  {
    "id": "INSP-2026-HK-016",
    "date": "2026-02-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Main Deck - Cutting Dryer Area",
    "type": "Housekeeping / Housekeeping",
    "inspector": "Cecep / Mahfud",
    "obsRefId": "",
    "findings": "Area clear and clean; no mud observed. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "ANDRE / DANI",
    "dueDate": "2026-02-26",
    "status": "Closed",
    "completionDate": "2026-02-26",
    "remarks": "Source: Housekeeping Report February 2026."
  },
  {
    "id": "INSP-2026-ESD-001",
    "date": "2026-02-25",
    "site": "ZHONGYOUHAI-16",
    "area": "ESD Engine GENSET No. 1",
    "type": "ESD Matrix",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "February 2026 ESD inspection average 10/10 for ESD Engine GENSET No. 1.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-02-25",
    "status": "Closed",
    "completionDate": "2026-02-25",
    "remarks": "Source: ESD Matrix Period Feb 2026."
  },
  {
    "id": "INSP-2026-ESD-002",
    "date": "2026-02-25",
    "site": "ZHONGYOUHAI-16",
    "area": "ESD Engine GENSET No. 2",
    "type": "ESD Matrix",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "February 2026 ESD inspection average 10/10 for ESD Engine GENSET No. 2.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-02-25",
    "status": "Closed",
    "completionDate": "2026-02-25",
    "remarks": "Source: ESD Matrix Period Feb 2026."
  },
  {
    "id": "INSP-2026-ESD-003",
    "date": "2026-02-25",
    "site": "ZHONGYOUHAI-16",
    "area": "ESD Engine GENSET No. 3",
    "type": "ESD Matrix",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "February 2026 ESD inspection average 10/10 for ESD Engine GENSET No. 3.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-02-25",
    "status": "Closed",
    "completionDate": "2026-02-25",
    "remarks": "Source: ESD Matrix Period Feb 2026."
  },
  {
    "id": "INSP-2026-ESD-004",
    "date": "2026-02-25",
    "site": "ZHONGYOUHAI-16",
    "area": "ESD Engine GENSET No. 4",
    "type": "ESD Matrix",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "February 2026 ESD inspection average 10/10 for ESD Engine GENSET No. 4.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-02-25",
    "status": "Closed",
    "completionDate": "2026-02-25",
    "remarks": "Source: ESD Matrix Period Feb 2026."
  },
  {
    "id": "INSP-2026-ESD-005",
    "date": "2026-02-25",
    "site": "ZHONGYOUHAI-16",
    "area": "ESD Engine GENSET No. 5",
    "type": "ESD Matrix",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "February 2026 ESD inspection average 10/10 for ESD Engine GENSET No. 5.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-02-25",
    "status": "Closed",
    "completionDate": "2026-02-25",
    "remarks": "Source: ESD Matrix Period Feb 2026."
  },
  {
    "id": "INSP-2026-ESD-006",
    "date": "2026-02-25",
    "site": "ZHONGYOUHAI-16",
    "area": "ESD Engine GENSET No. 6",
    "type": "ESD Matrix",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "February 2026 ESD inspection average 10/10 for ESD Engine GENSET No. 6.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-02-25",
    "status": "Closed",
    "completionDate": "2026-02-25",
    "remarks": "Source: ESD Matrix Period Feb 2026."
  },
  {
    "id": "INSP-2026-ESD-007",
    "date": "2026-02-25",
    "site": "ZHONGYOUHAI-16",
    "area": "Gas Detector Zone 1",
    "type": "Fire & Gas Detection",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "February 2026 ESD inspection average 10/10 for Gas Detector Zone 1.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-02-25",
    "status": "Closed",
    "completionDate": "2026-02-25",
    "remarks": "Source: ESD Matrix Period Feb 2026."
  },
  {
    "id": "INSP-2026-ESD-008",
    "date": "2026-02-25",
    "site": "ZHONGYOUHAI-16",
    "area": "Gas Detector Zone 2",
    "type": "Fire & Gas Detection",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "February 2026 ESD inspection average 10/10 for Gas Detector Zone 2.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-02-25",
    "status": "Closed",
    "completionDate": "2026-02-25",
    "remarks": "Source: ESD Matrix Period Feb 2026."
  },
  {
    "id": "INSP-2026-ESD-009",
    "date": "2026-02-25",
    "site": "ZHONGYOUHAI-16",
    "area": "Smoke Detector",
    "type": "Fire & Gas Detection",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "February 2026 ESD inspection average 10/10 for Smoke Detector.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-02-25",
    "status": "Closed",
    "completionDate": "2026-02-25",
    "remarks": "Source: ESD Matrix Period Feb 2026."
  },
  {
    "id": "INSP-2026-ESD-010",
    "date": "2026-02-25",
    "site": "ZHONGYOUHAI-16",
    "area": "Heat / Fire Detector",
    "type": "Fire & Gas Detection",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "February 2026 ESD inspection average 10/10 for Heat / Fire Detector.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-02-25",
    "status": "Closed",
    "completionDate": "2026-02-25",
    "remarks": "Source: ESD Matrix Period Feb 2026."
  },
  {
    "id": "INSP-2026-SECE-001",
    "date": "2026-02-25",
    "site": "ZHONGYOUHAI-16",
    "area": "Alarm System",
    "type": "SECE - Prevention",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Alarm System marked Good / 100% in February 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-02-25",
    "status": "Closed",
    "completionDate": "2026-02-25",
    "remarks": "Source: SECE-Feb-2026.pdf."
  },
  {
    "id": "INSP-2026-SECE-002",
    "date": "2026-02-25",
    "site": "ZHONGYOUHAI-16",
    "area": "Escape Route / Rig Floor Hazardous Area",
    "type": "SECE - Prevention",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Escape Route / Rig Floor Hazardous Area marked Good / 100% in February 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-02-25",
    "status": "Closed",
    "completionDate": "2026-02-25",
    "remarks": "Source: SECE-Feb-2026.pdf."
  },
  {
    "id": "INSP-2026-SECE-003",
    "date": "2026-02-25",
    "site": "ZHONGYOUHAI-16",
    "area": "Key Personnel Well Control Certification",
    "type": "SECE - Prevention",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Key Personnel Well Control Certification marked Good / 100% in February 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-02-25",
    "status": "Closed",
    "completionDate": "2026-02-25",
    "remarks": "Source: SECE-Feb-2026.pdf."
  },
  {
    "id": "INSP-2026-SECE-004",
    "date": "2026-02-25",
    "site": "ZHONGYOUHAI-16",
    "area": "Equipment Condition",
    "type": "SECE - Control",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Equipment Condition marked Good / 100% in February 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-02-25",
    "status": "Closed",
    "completionDate": "2026-02-25",
    "remarks": "Source: SECE-Feb-2026.pdf."
  },
  {
    "id": "INSP-2026-SECE-005",
    "date": "2026-02-25",
    "site": "ZHONGYOUHAI-16",
    "area": "Fire and Gas Detection System",
    "type": "SECE - Control",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Fire and Gas Detection System marked Good / 100% in February 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-02-25",
    "status": "Closed",
    "completionDate": "2026-02-25",
    "remarks": "Source: SECE-Feb-2026.pdf."
  },
  {
    "id": "INSP-2026-SECE-006",
    "date": "2026-02-25",
    "site": "ZHONGYOUHAI-16",
    "area": "Fire Fighting System",
    "type": "SECE - Mitigation",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Fire Fighting System marked Good / 100% in February 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-02-25",
    "status": "Closed",
    "completionDate": "2026-02-25",
    "remarks": "Source: SECE-Feb-2026.pdf."
  },
  {
    "id": "INSP-2026-SECE-007",
    "date": "2026-02-25",
    "site": "ZHONGYOUHAI-16",
    "area": "Muster Point Condition",
    "type": "SECE - Evacuation",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Muster Point Condition marked Good / 100% in February 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-02-25",
    "status": "Closed",
    "completionDate": "2026-02-25",
    "remarks": "Source: SECE-Feb-2026.pdf."
  },
  {
    "id": "INSP-2026-SECE-008",
    "date": "2026-02-25",
    "site": "ZHONGYOUHAI-16",
    "area": "Escape Route Condition",
    "type": "SECE - Evacuation",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Escape Route Condition marked Good / 100% in February 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-02-25",
    "status": "Closed",
    "completionDate": "2026-02-25",
    "remarks": "Source: SECE-Feb-2026.pdf."
  },
  {
    "id": "INSP-2026-SECE-009",
    "date": "2026-02-25",
    "site": "ZHONGYOUHAI-16",
    "area": "Life Saving Equipment",
    "type": "SECE - Evacuation",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Life Saving Equipment marked Good / 100% in February 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-02-25",
    "status": "Closed",
    "completionDate": "2026-02-25",
    "remarks": "Source: SECE-Feb-2026.pdf."
  },
  {
    "id": "INSP-2026-MAR-HK-001",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Engine Room - Below Deck",
    "type": "Housekeeping / Fire Equipment",
    "inspector": "Irwin / Armand",
    "obsRefId": "",
    "findings": "Walkway clear; emergency firefighting equipment inspected and ready for use. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: Housekeeping Report- March 2026."
  },
  {
    "id": "INSP-2026-MAR-HK-003",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Motorman Workshop - Below Deck",
    "type": "Housekeeping / Tool Control",
    "inspector": "Irwin / Armand",
    "obsRefId": "",
    "findings": "Walkway clear; emergency route marking sighted; tools and equipment tidy. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: Housekeeping Report- March 2026."
  },
  {
    "id": "INSP-2026-MAR-HK-004",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Mud Pit - Below Deck",
    "type": "Housekeeping / Spill Prevention",
    "inspector": "Irwin / Armand",
    "obsRefId": "",
    "findings": "Walkway clear and dry; no spillage observed in mud pit area. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: Housekeeping Report- March 2026."
  },
  {
    "id": "INSP-2026-MAR-HK-005",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Mud Pump - Below Deck",
    "type": "Housekeeping / Emergency Route",
    "inspector": "Irwin / Armand",
    "obsRefId": "",
    "findings": "Mud pump mezzanine area clean; walkway clear; emergency route signage sighted. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: Housekeeping Report- March 2026."
  },
  {
    "id": "INSP-2026-MAR-HK-007",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Lower Sack Room - Below Deck",
    "type": "Housekeeping / Escape Route",
    "inspector": "Irwin / Armand",
    "obsRefId": "",
    "findings": "Working floor clean and dry; no blockage on escape route. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: Housekeeping Report- March 2026."
  },
  {
    "id": "INSP-2026-MAR-HK-009",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Upper Sack Room - Below Deck",
    "type": "Housekeeping / Housekeeping",
    "inspector": "Irwin / Armand",
    "obsRefId": "OBS-2026-MAR-HK-009",
    "findings": "Working floor is dirty and requires immediate cleaning. Good housekeeping must be maintained to ensure safety. Score: 75%",
    "risk": "Medium",
    "legalRef": "",
    "correctiveAction": "Clean Upper Sack Room working floor immediately and maintain good housekeeping condition.",
    "responsible": "ANDRE / DANI",
    "dueDate": "2026-03-31",
    "status": "Open",
    "completionDate": "",
    "remarks": "Source: Housekeeping Report- March 2026."
  },
  {
    "id": "INSP-2026-MAR-HK-010",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Main Deck - Portside",
    "type": "Housekeeping / Housekeeping",
    "inspector": "Irwin / Armand",
    "obsRefId": "",
    "findings": "Walkway clean and dry. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: Housekeeping Report- March 2026."
  },
  {
    "id": "INSP-2026-MAR-HK-011",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Main Deck - Loading Hatch Portside",
    "type": "Housekeeping / Emergency Route",
    "inspector": "Irwin / Armand",
    "obsRefId": "",
    "findings": "Area clear; emergency route free from obstruction. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: Housekeeping Report- March 2026."
  },
  {
    "id": "INSP-2026-MAR-HK-012",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Main Deck - Bosun Store Portleg",
    "type": "Housekeeping / Emergency Route",
    "inspector": "Irwin / Armand",
    "obsRefId": "",
    "findings": "Area clear; emergency route signage sighted. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: Housekeeping Report- March 2026."
  },
  {
    "id": "INSP-2026-MAR-HK-013",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Main Deck - Center Walkway",
    "type": "Housekeeping / Emergency Route",
    "inspector": "Irwin / Armand",
    "obsRefId": "",
    "findings": "Area clear; emergency route signage sighted. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: Housekeeping Report- March 2026."
  },
  {
    "id": "INSP-2026-MAR-HK-014",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Main Deck - Cutting Dryer Area Center Main Deck",
    "type": "Housekeeping / Housekeeping",
    "inspector": "Irwin / Armand",
    "obsRefId": "",
    "findings": "Observed area clear and clean; no mud on deck. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: Housekeeping Report- March 2026."
  },
  {
    "id": "INSP-2026-MAR-HK-015",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "BOP Area",
    "type": "Housekeeping / Housekeeping",
    "inspector": "Irwin / Armand",
    "obsRefId": "",
    "findings": "Clean; no spill. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: Housekeeping Report- March 2026."
  },
  {
    "id": "INSP-2026-MAR-ESD-001",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "ESD Engine GENSET No. 1 - LOCAL",
    "type": "ESD Matrix",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "March 2026 ESD matrix recorded average score 10/10 for ESD Engine GENSET No. 1 - LOCAL.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: ESD Matrix Period Mar 2026."
  },
  {
    "id": "INSP-2026-MAR-ESD-002",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "ESD Engine GENSET No. 2 - LOCAL",
    "type": "ESD Matrix",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "March 2026 ESD matrix recorded average score 10/10 for ESD Engine GENSET No. 2 - LOCAL.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: ESD Matrix Period Mar 2026."
  },
  {
    "id": "INSP-2026-MAR-ESD-003",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "ESD Engine GENSET No. 3 - LOCAL",
    "type": "ESD Matrix",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "March 2026 ESD matrix recorded average score 10/10 for ESD Engine GENSET No. 3 - LOCAL.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: ESD Matrix Period Mar 2026."
  },
  {
    "id": "INSP-2026-MAR-ESD-004",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "ESD Engine GENSET No. 4 - LOCAL",
    "type": "ESD Matrix",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "March 2026 ESD matrix recorded average score 10/10 for ESD Engine GENSET No. 4 - LOCAL.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: ESD Matrix Period Mar 2026."
  },
  {
    "id": "INSP-2026-MAR-ESD-005",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "ESD Engine GENSET No. 5 - LOCAL",
    "type": "ESD Matrix",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "March 2026 ESD matrix recorded average score 10/10 for ESD Engine GENSET No. 5 - LOCAL.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: ESD Matrix Period Mar 2026."
  },
  {
    "id": "INSP-2026-MAR-ESD-006",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "ESD Engine GENSET No. 6 - LOCAL",
    "type": "ESD Matrix",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "March 2026 ESD matrix recorded average score 10/10 for ESD Engine GENSET No. 6 - LOCAL.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: ESD Matrix Period Mar 2026."
  },
  {
    "id": "INSP-2026-MAR-ESD-007",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Gas Detector Zone 1",
    "type": "Fire & Gas Detection",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "March 2026 ESD matrix recorded average score 10/10 for Gas Detector Zone 1.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: ESD Matrix Period Mar 2026."
  },
  {
    "id": "INSP-2026-MAR-ESD-008",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Gas Detector Zone 2",
    "type": "Fire & Gas Detection",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "March 2026 ESD matrix recorded average score 10/10 for Gas Detector Zone 2.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: ESD Matrix Period Mar 2026."
  },
  {
    "id": "INSP-2026-MAR-ESD-009",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Smoke Detector",
    "type": "Fire & Gas Detection",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "March 2026 ESD matrix recorded average score 10/10 for Smoke Detector.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: ESD Matrix Period Mar 2026."
  },
  {
    "id": "INSP-2026-MAR-ESD-010",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Heat / Fire Detector",
    "type": "Fire & Gas Detection",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "March 2026 ESD matrix recorded average score 10/10 for Heat / Fire Detector.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: ESD Matrix Period Mar 2026."
  },
  {
    "id": "INSP-2026-MAR-SECE-001",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Alarm System",
    "type": "SECE - Prevention",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Alarm System marked Good / 100% in March 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: SECE Mar, 2026."
  },
  {
    "id": "INSP-2026-MAR-SECE-002",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Escape Route / Rig Floor Hazardous Area",
    "type": "SECE - Prevention",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Escape Route / Rig Floor Hazardous Area marked Good / 100% in March 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: SECE Mar, 2026."
  },
  {
    "id": "INSP-2026-MAR-SECE-003",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Key Personnel Well Control Certification",
    "type": "SECE - Prevention",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Key Personnel Well Control Certification marked Good / 100% in March 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: SECE Mar, 2026."
  },
  {
    "id": "INSP-2026-MAR-SECE-004",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "BOP Control Equipment",
    "type": "SECE - Control",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "BOP Control Equipment marked Good / 100% in March 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: SECE Mar, 2026."
  },
  {
    "id": "INSP-2026-MAR-SECE-005",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "ESD System",
    "type": "SECE - Control",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "ESD System marked Good / 100% in March 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: SECE Mar, 2026."
  },
  {
    "id": "INSP-2026-MAR-SECE-006",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Fire and Gas Detection System",
    "type": "SECE - Control",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Fire and Gas Detection System marked Good / 100% in March 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: SECE Mar, 2026."
  },
  {
    "id": "INSP-2026-MAR-SECE-007",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Fire Fighting System",
    "type": "SECE - Mitigation",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Fire Fighting System marked Good / 100% in March 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: SECE Mar, 2026."
  },
  {
    "id": "INSP-2026-MAR-SECE-008",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Muster Point Condition",
    "type": "SECE - Evacuation",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Muster Point Condition marked Good / 100% in March 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: SECE Mar, 2026."
  },
  {
    "id": "INSP-2026-MAR-SECE-009",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Escape Route Condition",
    "type": "SECE - Evacuation",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Escape Route Condition marked Good / 100% in March 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: SECE Mar, 2026."
  },
  {
    "id": "INSP-2026-MAR-SECE-010",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "area": "Life Saving Equipment",
    "type": "SECE - Evacuation",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Life Saving Equipment marked Good / 100% in March 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-03-26",
    "status": "Closed",
    "completionDate": "2026-03-26",
    "remarks": "Source: SECE Mar, 2026."
  },
  {
    "id": "INSP-2026-APR-HK-001",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "area": "Engine Room - Below Deck",
    "type": "Housekeeping / Fire Equipment",
    "inspector": "Mahfud / Cecep",
    "obsRefId": "",
    "findings": "Area between engine is clean and no obstruction; emergency firefighting equipment inspected and ready. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "BAMBANG / IHSANUL",
    "dueDate": "2026-04-30",
    "status": "Closed",
    "completionDate": "2026-04-30",
    "remarks": "Source: Signed_Housekeeping Report- April 2026."
  },
  {
    "id": "INSP-2026-APR-HK-002",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "area": "Central Cooler Area - Below Deck",
    "type": "Housekeeping / Emergency Route",
    "inspector": "Mahfud / Cecep",
    "obsRefId": "",
    "findings": "Walkway clear; emergency route marking sighted; tools and equipment tidy. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "BAMBANG / IHSANUL",
    "dueDate": "2026-04-30",
    "status": "Closed",
    "completionDate": "2026-04-30",
    "remarks": "Source: Signed_Housekeeping Report- April 2026."
  },
  {
    "id": "INSP-2026-APR-HK-003",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "area": "Mud Pit - Below Deck",
    "type": "Housekeeping / Spill Prevention",
    "inspector": "Mahfud / Cecep",
    "obsRefId": "",
    "findings": "Walkway clear and dry; no spillage in mud pit area. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "BAMBANG / IHSANUL",
    "dueDate": "2026-04-30",
    "status": "Closed",
    "completionDate": "2026-04-30",
    "remarks": "Source: Signed_Housekeeping Report- April 2026."
  },
  {
    "id": "INSP-2026-APR-HK-004",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "area": "Mud Pump - Below Deck",
    "type": "Housekeeping / Emergency Route",
    "inspector": "Mahfud / Cecep",
    "obsRefId": "",
    "findings": "Mud pump mezzanine clean; walkway clear; emergency route signage sighted. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "BAMBANG / IHSANUL",
    "dueDate": "2026-04-30",
    "status": "Closed",
    "completionDate": "2026-04-30",
    "remarks": "Source: Signed_Housekeeping Report- April 2026."
  },
  {
    "id": "INSP-2026-APR-HK-005",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "area": "Lower Sack Room - Below Deck",
    "type": "Housekeeping / Escape Route",
    "inspector": "Mahfud / Cecep",
    "obsRefId": "",
    "findings": "Working floor clean and dry; no blockage on escape route. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "BAMBANG / IHSANUL",
    "dueDate": "2026-04-30",
    "status": "Closed",
    "completionDate": "2026-04-30",
    "remarks": "Source: Signed_Housekeeping Report- April 2026."
  },
  {
    "id": "INSP-2026-APR-HK-006",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "area": "Upper Sack Room - Below Deck",
    "type": "Housekeeping / Housekeeping",
    "inspector": "Mahfud / Cecep",
    "obsRefId": "",
    "findings": "Working floor clean; housekeeping continuously maintained. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "BAMBANG / IHSANUL",
    "dueDate": "2026-04-30",
    "status": "Closed",
    "completionDate": "2026-04-30",
    "remarks": "Source: Signed_Housekeeping Report- April 2026."
  },
  {
    "id": "INSP-2026-APR-HK-007",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "area": "Under Shaker",
    "type": "Housekeeping / Housekeeping",
    "inspector": "Mahfud / Cecep",
    "obsRefId": "",
    "findings": "Walkway clean from spills; tools and equipment tidy. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "BAMBANG / IHSANUL",
    "dueDate": "2026-04-30",
    "status": "Closed",
    "completionDate": "2026-04-30",
    "remarks": "Source: Signed_Housekeeping Report- April 2026."
  },
  {
    "id": "INSP-2026-APR-HK-008",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "area": "Shaker Room",
    "type": "Housekeeping / Housekeeping",
    "inspector": "Mahfud / Cecep",
    "obsRefId": "",
    "findings": "Walkway clean, free from obstruction; no mud or spills on floor. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "BAMBANG / IHSANUL",
    "dueDate": "2026-04-30",
    "status": "Closed",
    "completionDate": "2026-04-30",
    "remarks": "Source: Signed_Housekeeping Report- April 2026."
  },
  {
    "id": "INSP-2026-APR-HK-009",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "area": "Main Deck - Bosun Store Portleg",
    "type": "Housekeeping / Emergency Route",
    "inspector": "Mahfud / Cecep",
    "obsRefId": "",
    "findings": "Area clear; emergency escape walkway no obstruction; hose across walkway covered with yellow/black cover. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "BAMBANG / IHSANUL",
    "dueDate": "2026-04-30",
    "status": "Closed",
    "completionDate": "2026-04-30",
    "remarks": "Source: Signed_Housekeeping Report- April 2026."
  },
  {
    "id": "INSP-2026-APR-HK-010",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "area": "STB Main Deck - Walkway STB Side Area",
    "type": "Housekeeping / Emergency Route",
    "inspector": "Mahfud / Cecep",
    "obsRefId": "",
    "findings": "Area recently painted and clean; emergency route signage sighted. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "BAMBANG / IHSANUL",
    "dueDate": "2026-04-30",
    "status": "Closed",
    "completionDate": "2026-04-30",
    "remarks": "Source: Signed_Housekeeping Report- April 2026."
  },
  {
    "id": "INSP-2026-APR-HK-011",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "area": "Cementing Unit Area",
    "type": "Housekeeping / Housekeeping",
    "inspector": "Mahfud / Cecep",
    "obsRefId": "",
    "findings": "Area clear and clean; no mud on deck. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "BAMBANG / IHSANUL",
    "dueDate": "2026-04-30",
    "status": "Closed",
    "completionDate": "2026-04-30",
    "remarks": "Source: Signed_Housekeeping Report- April 2026."
  },
  {
    "id": "INSP-2026-APR-HK-012",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "area": "Rig Floor",
    "type": "Housekeeping / Housekeeping",
    "inspector": "Mahfud / Cecep",
    "obsRefId": "",
    "findings": "Clean floor; no oil or mud at path between catwalk and rotary table. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "BAMBANG / IHSANUL",
    "dueDate": "2026-04-30",
    "status": "Closed",
    "completionDate": "2026-04-30",
    "remarks": "Source: Signed_Housekeeping Report- April 2026."
  },
  {
    "id": "INSP-2026-APR-HK-013",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "area": "Under Cantilever",
    "type": "Housekeeping / Housekeeping",
    "inspector": "Mahfud / Cecep",
    "obsRefId": "",
    "findings": "Narrow area cleaned by drilling and marine crew; good housekeeping effort. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "BAMBANG / IHSANUL",
    "dueDate": "2026-04-30",
    "status": "Closed",
    "completionDate": "2026-04-30",
    "remarks": "Source: Signed_Housekeeping Report- April 2026."
  },
  {
    "id": "INSP-2026-APR-HK-014",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "area": "BOP Stamp Area",
    "type": "Housekeeping / Housekeeping",
    "inspector": "Mahfud / Cecep",
    "obsRefId": "",
    "findings": "Clean; no spill. Score: 100%",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain current condition.",
    "responsible": "BAMBANG / IHSANUL",
    "dueDate": "2026-04-30",
    "status": "Closed",
    "completionDate": "2026-04-30",
    "remarks": "Source: Signed_Housekeeping Report- April 2026."
  },
  {
    "id": "INSP-2026-APR-ESD-001",
    "date": "2026-04-27",
    "site": "ZHONGYOUHAI-16",
    "area": "ESD Engine GENSET No. 1 - LOCAL",
    "type": "ESD Matrix",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "April 2026 ESD matrix recorded average score 10/10 for ESD Engine GENSET No. 1 - LOCAL.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-04-27",
    "status": "Closed",
    "completionDate": "2026-04-27",
    "remarks": "Source: ESD Matrix Period April 2026."
  },
  {
    "id": "INSP-2026-APR-ESD-002",
    "date": "2026-04-27",
    "site": "ZHONGYOUHAI-16",
    "area": "ESD Engine GENSET No. 2 - LOCAL",
    "type": "ESD Matrix",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "April 2026 ESD matrix recorded average score 10/10 for ESD Engine GENSET No. 2 - LOCAL.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-04-27",
    "status": "Closed",
    "completionDate": "2026-04-27",
    "remarks": "Source: ESD Matrix Period April 2026."
  },
  {
    "id": "INSP-2026-APR-ESD-003",
    "date": "2026-04-27",
    "site": "ZHONGYOUHAI-16",
    "area": "ESD Engine GENSET No. 3 - LOCAL",
    "type": "ESD Matrix",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "April 2026 ESD matrix recorded average score 10/10 for ESD Engine GENSET No. 3 - LOCAL.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-04-27",
    "status": "Closed",
    "completionDate": "2026-04-27",
    "remarks": "Source: ESD Matrix Period April 2026."
  },
  {
    "id": "INSP-2026-APR-ESD-004",
    "date": "2026-04-27",
    "site": "ZHONGYOUHAI-16",
    "area": "ESD Engine GENSET No. 4 - LOCAL",
    "type": "ESD Matrix",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "April 2026 ESD matrix recorded average score 10/10 for ESD Engine GENSET No. 4 - LOCAL.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-04-27",
    "status": "Closed",
    "completionDate": "2026-04-27",
    "remarks": "Source: ESD Matrix Period April 2026."
  },
  {
    "id": "INSP-2026-APR-ESD-005",
    "date": "2026-04-27",
    "site": "ZHONGYOUHAI-16",
    "area": "ESD Engine GENSET No. 5 - LOCAL",
    "type": "ESD Matrix",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "April 2026 ESD matrix recorded average score 10/10 for ESD Engine GENSET No. 5 - LOCAL.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-04-27",
    "status": "Closed",
    "completionDate": "2026-04-27",
    "remarks": "Source: ESD Matrix Period April 2026."
  },
  {
    "id": "INSP-2026-APR-ESD-006",
    "date": "2026-04-27",
    "site": "ZHONGYOUHAI-16",
    "area": "ESD Engine GENSET No. 6 - LOCAL",
    "type": "ESD Matrix",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "April 2026 ESD matrix recorded average score 10/10 for ESD Engine GENSET No. 6 - LOCAL.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-04-27",
    "status": "Closed",
    "completionDate": "2026-04-27",
    "remarks": "Source: ESD Matrix Period April 2026."
  },
  {
    "id": "INSP-2026-APR-ESD-007",
    "date": "2026-04-27",
    "site": "ZHONGYOUHAI-16",
    "area": "Gas Detector Zone 1",
    "type": "Fire & Gas Detection",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "April 2026 ESD matrix recorded average score 10/10 for Gas Detector Zone 1.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-04-27",
    "status": "Closed",
    "completionDate": "2026-04-27",
    "remarks": "Source: ESD Matrix Period April 2026."
  },
  {
    "id": "INSP-2026-APR-ESD-008",
    "date": "2026-04-27",
    "site": "ZHONGYOUHAI-16",
    "area": "Gas Detector Zone 2",
    "type": "Fire & Gas Detection",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "April 2026 ESD matrix recorded average score 10/10 for Gas Detector Zone 2.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-04-27",
    "status": "Closed",
    "completionDate": "2026-04-27",
    "remarks": "Source: ESD Matrix Period April 2026."
  },
  {
    "id": "INSP-2026-APR-ESD-009",
    "date": "2026-04-27",
    "site": "ZHONGYOUHAI-16",
    "area": "Smoke Detector",
    "type": "Fire & Gas Detection",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "April 2026 ESD matrix recorded average score 10/10 for Smoke Detector.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-04-27",
    "status": "Closed",
    "completionDate": "2026-04-27",
    "remarks": "Source: ESD Matrix Period April 2026."
  },
  {
    "id": "INSP-2026-APR-ESD-010",
    "date": "2026-04-27",
    "site": "ZHONGYOUHAI-16",
    "area": "Heat / Fire Detector",
    "type": "Fire & Gas Detection",
    "inspector": "IT Engineer",
    "obsRefId": "",
    "findings": "April 2026 ESD matrix recorded average score 10/10 for Heat / Fire Detector.",
    "risk": "Low",
    "legalRef": "",
    "correctiveAction": "Maintain yearly ESD inspection plan and monthly detector loop-by-loop inspection.",
    "responsible": "IT Engineer / PHM Co. Man",
    "dueDate": "2026-04-27",
    "status": "Closed",
    "completionDate": "2026-04-27",
    "remarks": "Source: ESD Matrix Period April 2026."
  },
  {
    "id": "INSP-2026-APR-SECE-001",
    "date": "2026-04-27",
    "site": "ZHONGYOUHAI-16",
    "area": "Ballast System",
    "type": "SECE - Prevention",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Ballast System marked Good / 100% in April 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-04-27",
    "status": "Closed",
    "completionDate": "2026-04-27",
    "remarks": "Source: SECE April, 2026."
  },
  {
    "id": "INSP-2026-APR-SECE-002",
    "date": "2026-04-27",
    "site": "ZHONGYOUHAI-16",
    "area": "Escape Route / Rig Floor Hazardous Area",
    "type": "SECE - Prevention",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Escape Route / Rig Floor Hazardous Area marked Good / 100% in April 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-04-27",
    "status": "Closed",
    "completionDate": "2026-04-27",
    "remarks": "Source: SECE April, 2026."
  },
  {
    "id": "INSP-2026-APR-SECE-003",
    "date": "2026-04-27",
    "site": "ZHONGYOUHAI-16",
    "area": "Key Personnel Well Control Certification",
    "type": "SECE - Prevention",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Key Personnel Well Control Certification marked Good / 100% in April 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-04-27",
    "status": "Closed",
    "completionDate": "2026-04-27",
    "remarks": "Source: SECE April, 2026."
  },
  {
    "id": "INSP-2026-APR-SECE-004",
    "date": "2026-04-27",
    "site": "ZHONGYOUHAI-16",
    "area": "BOP Control Equipment",
    "type": "SECE - Control",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "BOP Control Equipment marked Good / 100% in April 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-04-27",
    "status": "Closed",
    "completionDate": "2026-04-27",
    "remarks": "Source: SECE April, 2026."
  },
  {
    "id": "INSP-2026-APR-SECE-005",
    "date": "2026-04-27",
    "site": "ZHONGYOUHAI-16",
    "area": "ESD System",
    "type": "SECE - Control",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "ESD System marked Good / 100% in April 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-04-27",
    "status": "Closed",
    "completionDate": "2026-04-27",
    "remarks": "Source: SECE April, 2026."
  },
  {
    "id": "INSP-2026-APR-SECE-006",
    "date": "2026-04-27",
    "site": "ZHONGYOUHAI-16",
    "area": "Fire and Gas Detection System",
    "type": "SECE - Control",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Fire and Gas Detection System marked Good / 100% in April 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-04-27",
    "status": "Closed",
    "completionDate": "2026-04-27",
    "remarks": "Source: SECE April, 2026."
  },
  {
    "id": "INSP-2026-APR-SECE-007",
    "date": "2026-04-27",
    "site": "ZHONGYOUHAI-16",
    "area": "Fire Fighting System",
    "type": "SECE - Mitigation",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Fire Fighting System marked Good / 100% in April 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-04-27",
    "status": "Closed",
    "completionDate": "2026-04-27",
    "remarks": "Source: SECE April, 2026."
  },
  {
    "id": "INSP-2026-APR-SECE-008",
    "date": "2026-04-27",
    "site": "ZHONGYOUHAI-16",
    "area": "Muster Point Condition",
    "type": "SECE - Evacuation",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Muster Point Condition marked Good / 100% in April 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-04-27",
    "status": "Closed",
    "completionDate": "2026-04-27",
    "remarks": "Source: SECE April, 2026."
  },
  {
    "id": "INSP-2026-APR-SECE-009",
    "date": "2026-04-27",
    "site": "ZHONGYOUHAI-16",
    "area": "Escape Route Condition",
    "type": "SECE - Evacuation",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Escape Route Condition marked Good / 100% in April 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-04-27",
    "status": "Closed",
    "completionDate": "2026-04-27",
    "remarks": "Source: SECE April, 2026."
  },
  {
    "id": "INSP-2026-APR-SECE-010",
    "date": "2026-04-27",
    "site": "ZHONGYOUHAI-16",
    "area": "Life Boat Condition",
    "type": "SECE - Evacuation",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Life Boat Condition marked Good / 100% in April 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-04-27",
    "status": "Closed",
    "completionDate": "2026-04-27",
    "remarks": "Source: SECE April, 2026."
  },
  {
    "id": "INSP-2026-APR-SECE-011",
    "date": "2026-04-27",
    "site": "ZHONGYOUHAI-16",
    "area": "Life Saving Equipment",
    "type": "SECE - Evacuation",
    "inspector": "Chief Electrician / Barge Master / Toolpusher / Company Man",
    "obsRefId": "",
    "findings": "Life Saving Equipment marked Good / 100% in April 2026 SECE inspection.",
    "risk": "Low",
    "legalRef": "ABS / OEM",
    "correctiveAction": "Maintain inspection and certification condition.",
    "responsible": "Rig Management Team",
    "dueDate": "2026-04-27",
    "status": "Closed",
    "completionDate": "2026-04-27",
    "remarks": "Source: SECE April, 2026."
  }
];

const actions = [
  {
    "id": "ACT-2026-001",
    "date": "2026-01-28",
    "site": "ZHONGYOUHAI-16",
    "category": "Helideck Safety",
    "action": "Reinstate and verify proper earthing for helideck boundary lights and conduct functional checks.",
    "responsible": "Chief Electrician",
    "dueDate": "2026-02-03",
    "priority": "High",
    "status": "Closed",
    "source": "MoM Project Manager January 2026"
  },
  {
    "id": "ACT-2026-002",
    "date": "2026-01-28",
    "site": "ZHONGYOUHAI-16",
    "category": "Dropped Object Prevention",
    "action": "Install or rectify anti-drop safety nets for light fittings in accordance with applicable standards.",
    "responsible": "Chief Electrician",
    "dueDate": "2026-02-03",
    "priority": "High",
    "status": "Closed",
    "source": "MoM Project Manager January 2026"
  },
  {
    "id": "ACT-2026-003",
    "date": "2026-01-28",
    "site": "ZHONGYOUHAI-16",
    "category": "Fire Safety",
    "action": "Replace damaged fire hydrant blind cap safety chain and inspect similar fittings for integrity.",
    "responsible": "Bargemaster",
    "dueDate": "2026-02-03",
    "priority": "High",
    "status": "Open",
    "source": "MoM Project Manager January 2026"
  },
  {
    "id": "ACT-2026-004",
    "date": "2026-01-28",
    "site": "ZHONGYOUHAI-16",
    "category": "Housekeeping",
    "action": "Remove all non-essential items from emergency generator room and reinforce housekeeping controls.",
    "responsible": "Chief Engineer",
    "dueDate": "2026-02-03",
    "priority": "Medium",
    "status": "Closed",
    "source": "MoM Project Manager January 2026"
  },
  {
    "id": "ACT-2026-005",
    "date": "2026-01-28",
    "site": "ZHONGYOUHAI-16",
    "category": "Certification / Inspection",
    "action": "Arrange inspection and re-certification of man-riding basket before inspection expiry date.",
    "responsible": "Bargemaster",
    "dueDate": "2026-02-03",
    "priority": "Medium",
    "status": "Open",
    "source": "MoM Project Manager January 2026"
  },
  {
    "id": "ACT-2026-FEB-HK-001",
    "date": "2026-02-26",
    "site": "ZHONGYOUHAI-16",
    "category": "Trip Hazard / Hose Management",
    "action": "Protect or remove hose from walkway and maintain clear access route.",
    "responsible": "ANDRE / DANI",
    "dueDate": "2026-03-05",
    "priority": "Medium",
    "status": "Open",
    "source": "Housekeeping Report February 2026"
  },
  {
    "id": "ACT-2026-FEB-HK-002",
    "date": "2026-02-26",
    "site": "ZHONGYOUHAI-16",
    "category": "Trip Hazard / Hose Management",
    "action": "Protect or remove hose from walkway and maintain clear access route.",
    "responsible": "ANDRE / DANI",
    "dueDate": "2026-03-05",
    "priority": "Medium",
    "status": "Open",
    "source": "Housekeeping Report February 2026"
  },
  {
    "id": "ACT-2026-MAR-HK-001",
    "date": "2026-03-26",
    "site": "ZHONGYOUHAI-16",
    "category": "Housekeeping / Cleanliness",
    "action": "Clean Upper Sack Room working floor immediately and maintain good housekeeping condition.",
    "responsible": "ANDRE / DANI",
    "dueDate": "2026-03-31",
    "priority": "Medium",
    "status": "Open",
    "source": "Housekeeping Report March 2026"
  },
  {
    "id": "ACT-2026-MAR-MOM-001",
    "date": "2026-03-10",
    "site": "ZHONGYOUHAI-16",
    "category": "CSMS / Audit",
    "action": "Conduct a CSMS re-audit.",
    "responsible": "HSE",
    "dueDate": "2026-03-31",
    "priority": "High",
    "status": "Open",
    "source": "MOM HSE Visit 7-10 March 2026"
  },
  {
    "id": "ACT-2026-MAR-MOM-002",
    "date": "2026-03-10",
    "site": "ZHONGYOUHAI-16",
    "category": "HSE Monitoring",
    "action": "Monitor all activities on ZYH-16 Rig, including main deck, cantilever, and rig floor, to ensure operations proceed smoothly, safely, and securely.",
    "responsible": "HSE",
    "dueDate": "2026-03-31",
    "priority": "Medium",
    "status": "Open",
    "source": "MOM HSE Visit 7-10 March 2026"
  },
  {
    "id": "ACT-2026-MAR-CERMAT-001",
    "date": "2026-03-24",
    "site": "ZHONGYOUHAI-16",
    "category": "CeRMAT / Lifting Safety",
    "action": "Personnel basket secondary sling knot issue corrected by reconnecting properly using a shackle.",
    "responsible": "Lifting Team",
    "dueDate": "2026-03-24",
    "priority": "Medium",
    "status": "Closed",
    "source": "Best of The best Cermat - March 2026.pptx"
  },
  {
    "id": "ACT-2026-APR-MOM-001",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "category": "Storage Room / Material Control",
    "action": "Some materials in storage room stacked too tightly; reorganize storage room for safe access and handling.",
    "responsible": "Material man",
    "dueDate": "2026-04-30",
    "priority": "Medium",
    "status": "Closed",
    "source": "April 2026 MOM / Management Visit"
  },
  {
    "id": "ACT-2026-APR-MOM-002",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "category": "Warehouse Labeling",
    "action": "Warehouse labeling not consistent; standardize labeling and update all labels.",
    "responsible": "Material man",
    "dueDate": "2026-04-30",
    "priority": "Medium",
    "status": "Closed",
    "source": "April 2026 MOM / Management Visit"
  },
  {
    "id": "ACT-2026-APR-MOM-003",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "category": "Fire Hose Cabinet",
    "action": "Fire hose cabinet needs checking for complete equipment and good condition.",
    "responsible": "BM",
    "dueDate": "2026-04-30",
    "priority": "Medium",
    "status": "Closed",
    "source": "April 2026 MOM / Management Visit"
  },
  {
    "id": "ACT-2026-APR-MOM-004",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "category": "Risk Awareness",
    "action": "Risk awareness during routine work needs strengthening through toolbox talks and supervision.",
    "responsible": "Toolpusher / Driller / BM",
    "dueDate": "2026-04-30",
    "priority": "Medium",
    "status": "Closed",
    "source": "April 2026 MOM / Management Visit"
  },
  {
    "id": "ACT-2026-APR-MOM-005",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "category": "Towing Communication",
    "action": "Communication and command during towing operations need clearer roles, signals and command lines.",
    "responsible": "All crew",
    "dueDate": "2026-04-30",
    "priority": "Medium",
    "status": "Closed",
    "source": "April 2026 MOM / Management Visit"
  },
  {
    "id": "ACT-2026-APR-MOM-006",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "category": "Safety Culture / MCU Database",
    "action": "Safety culture improved and MCU personnel database established for health status tracking.",
    "responsible": "HSE",
    "dueDate": "2026-04-30",
    "priority": "Medium",
    "status": "Closed",
    "source": "April 2026 MOM / Management Visit"
  },
  {
    "id": "ACT-2026-APR-MOM-007",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "category": "Pre SIMOPS Meeting",
    "action": "Pre SIMOPS Meeting SNB WPN-3 conducted / recorded.",
    "responsible": "HSE",
    "dueDate": "2026-04-30",
    "priority": "Medium",
    "status": "Closed",
    "source": "April 2026 MOM / Management Visit"
  },
  {
    "id": "ACT-2026-APR-CERMAT-001",
    "date": "2026-04-19",
    "site": "ZHONGYOUHAI-16",
    "category": "CeRMAT / Cable Safety",
    "action": "Cable stuck / entangled risk during skidding corrected by rolling cable out from stuck area.",
    "responsible": "Rig Crew",
    "dueDate": "2026-04-19",
    "priority": "Medium",
    "status": "Closed",
    "source": "Best of The best Cermat - April 2026.pptx"
  },
  {
    "id": "ACT-2026-JAN-CERMAT-001",
    "date": "2026-01-25",
    "site": "ZHONGYOUHAI-16",
    "category": "CeRMAT / Dropped Object Prevention",
    "action": "Scrap material removed from cutting dryer underside before lifting to prevent dropped object hazard.",
    "responsible": "Rig Crew",
    "dueDate": "2026-01-25",
    "priority": "Medium",
    "status": "Closed",
    "source": "Monthly_Report_Januari_2026.pptx"
  }
];

const ncrs = [];

const audits = [
  {
    "id": "AUD-2026-001",
    "date": "2026-01-28",
    "site": "ZHONGYOUHAI-16",
    "type": "Internal",
    "auditor": "Yao Kai / Jackson",
    "scope": "Management Visit / HSE Implementation Review",
    "findings": 5,
    "score": 90,
    "ncrRaised": 0,
    "actionRequired": "Yes",
    "status": "In Progress"
  },
  {
    "id": "AUD-2026-002",
    "date": "2026-02-28",
    "site": "ZHONGYOUHAI-16",
    "type": "Internal",
    "auditor": "Hanifah Fitriani",
    "scope": "HSE Visit / PJSM / Weekly Safety Meeting / Activity Monitoring",
    "findings": 0,
    "score": 100,
    "ncrRaised": 0,
    "actionRequired": "No",
    "status": "Closed"
  },
  {
    "id": "AUD-2026-MAR-HSE-VISIT",
    "date": "2026-03-10",
    "site": "ZHONGYOUHAI-16",
    "type": "Internal / HSE Visit",
    "auditor": "Hanifah Fitriani",
    "scope": "HSE Visit / CSMS Re-audit / Activity Monitoring on main deck, cantilever and rig floor",
    "findings": 2,
    "score": 100,
    "ncrRaised": 0,
    "actionRequired": "Yes",
    "status": "Open"
  },
  {
    "id": "AUD-2026-APR-MGT-VISIT",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "type": "Management Visit",
    "auditor": "Jackson / Management Team",
    "scope": "Operational meetings, site inspection, HSE implementation, equipment integrity, housekeeping and material control",
    "findings": 5,
    "score": 100,
    "ncrRaised": 0,
    "actionRequired": "Yes",
    "status": "Closed"
  }
];

const ptws = [];

const trainingSummary = {
  reportTitle: "ZHONGYOUHAI-16 Training Compliance Report",
  sourceFile: "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
  lastUpdated: "2026-06-03",
  totalRequirements: 1285,
  validRecords: 1272,
  expiredRecords: 13,
  expiringSoonRecords: 0,
  notRequiredRecords: 1957,
  compliance: 98.99,
};

const trainings = [
  {
    "id": "TRN-2026-LATEST-001",
    "employeeName": "Medical Examination (OGUK or Equivalent)",
    "employeeId": "168 Required / 164 Valid / 4 Expired",
    "site": "ZHONGYOUHAI-16",
    "department": "Training Compliance",
    "type": "Mandatory / Certification",
    "trainer": "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
    "date": "2026-06-03",
    "expiryDate": "Not Required: 0; Compliance: 97.62%",
    "status": "Attention Required"
  },
  {
    "id": "TRN-2026-LATEST-002",
    "employeeName": "Basic Offshore Safety Training (Basic Fire Fighting, Basic First Aid, Sea Survival & HUET)",
    "employeeId": "168 Required / 168 Valid / 0 Expired",
    "site": "ZHONGYOUHAI-16",
    "department": "Training Compliance",
    "type": "Mandatory / Certification",
    "trainer": "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
    "date": "2026-06-03",
    "expiryDate": "Not Required: 118; Compliance: 100%",
    "status": "Valid"
  },
  {
    "id": "TRN-2026-LATEST-003",
    "employeeName": "Well Control IWCF Level 4",
    "employeeId": "24 Required / 24 Valid / 0 Expired",
    "site": "ZHONGYOUHAI-16",
    "department": "Training Compliance",
    "type": "Mandatory / Certification",
    "trainer": "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
    "date": "2026-06-03",
    "expiryDate": "Not Required: 122; Compliance: 100%",
    "status": "Valid"
  },
  {
    "id": "TRN-2026-LATEST-004",
    "employeeName": "Drilling Rig Personnel Certification (SKKNI)",
    "employeeId": "61 Required / 61 Valid / 0 Expired",
    "site": "ZHONGYOUHAI-16",
    "department": "Training Compliance",
    "type": "Mandatory / Certification",
    "trainer": "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
    "date": "2026-06-03",
    "expiryDate": "Not Required: 0; Compliance: 100%",
    "status": "Valid"
  },
  {
    "id": "TRN-2026-LATEST-005",
    "employeeName": "Advanced First Aid (for First Aider)",
    "employeeId": "71 Required / 71 Valid / 0 Expired",
    "site": "ZHONGYOUHAI-16",
    "department": "Training Compliance",
    "type": "Mandatory / Certification",
    "trainer": "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
    "date": "2026-06-03",
    "expiryDate": "Not Required: 0; Compliance: 100%",
    "status": "Valid"
  },
  {
    "id": "TRN-2026-LATEST-006",
    "employeeName": "Advanced Fire Fighting (for fire team member)",
    "employeeId": "31 Required / 31 Valid / 0 Expired",
    "site": "ZHONGYOUHAI-16",
    "department": "Training Compliance",
    "type": "Mandatory / Certification",
    "trainer": "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
    "date": "2026-06-03",
    "expiryDate": "Not Required: 0; Compliance: 100%",
    "status": "Valid"
  },
  {
    "id": "TRN-2026-LATEST-007",
    "employeeName": "Crane Operator",
    "employeeId": "10 Required / 10 Valid / 0 Expired",
    "site": "ZHONGYOUHAI-16",
    "department": "Training Compliance",
    "type": "Mandatory / Certification",
    "trainer": "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
    "date": "2026-06-03",
    "expiryDate": "Not Required: 79; Compliance: 100%",
    "status": "Valid"
  },
  {
    "id": "TRN-2026-LATEST-008",
    "employeeName": "BOP hoist (Overhead Crane) Operator",
    "employeeId": "6 Required / 6 Valid / 0 Expired",
    "site": "ZHONGYOUHAI-16",
    "department": "Training Compliance",
    "type": "Mandatory / Certification",
    "trainer": "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
    "date": "2026-06-03",
    "expiryDate": "Not Required: 0; Compliance: 100%",
    "status": "Valid"
  },
  {
    "id": "TRN-2026-LATEST-009",
    "employeeName": "Forklift Operator",
    "employeeId": "27 Required / 24 Valid / 3 Expired",
    "site": "ZHONGYOUHAI-16",
    "department": "Training Compliance",
    "type": "Mandatory / Certification",
    "trainer": "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
    "date": "2026-06-03",
    "expiryDate": "Not Required: 79; Compliance: 88.89%",
    "status": "Attention Required"
  },
  {
    "id": "TRN-2026-LATEST-010",
    "employeeName": "Basic Scaffolder",
    "employeeId": "35 Required / 35 Valid / 0 Expired",
    "site": "ZHONGYOUHAI-16",
    "department": "Training Compliance",
    "type": "Mandatory / Certification",
    "trainer": "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
    "date": "2026-06-03",
    "expiryDate": "Not Required: 105; Compliance: 100%",
    "status": "Valid"
  },
  {
    "id": "TRN-2026-LATEST-011",
    "employeeName": "Advanced Scaffolder",
    "employeeId": "16 Required / 11 Valid / 5 Expired",
    "site": "ZHONGYOUHAI-16",
    "department": "Training Compliance",
    "type": "Mandatory / Certification",
    "trainer": "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
    "date": "2026-06-03",
    "expiryDate": "Not Required: 122; Compliance: 68.75%",
    "status": "Attention Required"
  },
  {
    "id": "TRN-2026-LATEST-012",
    "employeeName": "Barge Stability",
    "employeeId": "21 Required / 21 Valid / 0 Expired",
    "site": "ZHONGYOUHAI-16",
    "department": "Training Compliance",
    "type": "Mandatory / Certification",
    "trainer": "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
    "date": "2026-06-03",
    "expiryDate": "Not Required: 94; Compliance: 100%",
    "status": "Valid"
  },
  {
    "id": "TRN-2026-LATEST-013",
    "employeeName": "Coxswains",
    "employeeId": "24 Required / 24 Valid / 0 Expired",
    "site": "ZHONGYOUHAI-16",
    "department": "Training Compliance",
    "type": "Mandatory / Certification",
    "trainer": "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
    "date": "2026-06-03",
    "expiryDate": "Not Required: 83; Compliance: 100%",
    "status": "Valid"
  },
  {
    "id": "TRN-2026-LATEST-014",
    "employeeName": "Overhead (BOP Crane) Operator",
    "employeeId": "6 Required / 6 Valid / 0 Expired",
    "site": "ZHONGYOUHAI-16",
    "department": "Training Compliance",
    "type": "Mandatory / Certification",
    "trainer": "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
    "date": "2026-06-03",
    "expiryDate": "Not Required: 111; Compliance: 100%",
    "status": "Valid"
  },
  {
    "id": "TRN-2026-LATEST-015",
    "employeeName": "Rigging / Slinging",
    "employeeId": "73 Required / 72 Valid / 1 Expired",
    "site": "ZHONGYOUHAI-16",
    "department": "Training Compliance",
    "type": "Mandatory / Certification",
    "trainer": "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
    "date": "2026-06-03",
    "expiryDate": "Not Required: 121; Compliance: 98.63%",
    "status": "Attention Required"
  },
  {
    "id": "TRN-2026-LATEST-016",
    "employeeName": "Use of breathing sets (basic)",
    "employeeId": "165 Required / 165 Valid / 0 Expired",
    "site": "ZHONGYOUHAI-16",
    "department": "Training Compliance",
    "type": "Mandatory / Certification",
    "trainer": "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
    "date": "2026-06-03",
    "expiryDate": "Not Required: 0; Compliance: 100%",
    "status": "Valid"
  },
  {
    "id": "TRN-2026-LATEST-017",
    "employeeName": "Use of breathing sets (advanced)",
    "employeeId": "100 Required / 100 Valid / 0 Expired",
    "site": "ZHONGYOUHAI-16",
    "department": "Training Compliance",
    "type": "Mandatory / Certification",
    "trainer": "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
    "date": "2026-06-03",
    "expiryDate": "Not Required: 88; Compliance: 100%",
    "status": "Valid"
  },
  {
    "id": "TRN-2026-LATEST-018",
    "employeeName": "RIG Induction",
    "employeeId": "168 Required / 168 Valid / 0 Expired",
    "site": "ZHONGYOUHAI-16",
    "department": "Training Compliance",
    "type": "Mandatory / Certification",
    "trainer": "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
    "date": "2026-06-03",
    "expiryDate": "Not Required: 0; Compliance: 100%",
    "status": "Valid"
  },
  {
    "id": "TRN-2026-LATEST-019",
    "employeeName": "IWCF Well Controllers / IADC Wellcap (Level 3 / Fundamentals)",
    "employeeId": "4 Required / 4 Valid / 0 Expired",
    "site": "ZHONGYOUHAI-16",
    "department": "Training Compliance",
    "type": "Mandatory / Certification",
    "trainer": "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
    "date": "2026-06-03",
    "expiryDate": "Not Required: 125; Compliance: 100%",
    "status": "Valid"
  },
  {
    "id": "TRN-2026-LATEST-020",
    "employeeName": "Confined Space Entry",
    "employeeId": "29 Required / 29 Valid / 0 Expired",
    "site": "ZHONGYOUHAI-16",
    "department": "Training Compliance",
    "type": "Mandatory / Certification",
    "trainer": "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
    "date": "2026-06-03",
    "expiryDate": "Not Required: 129; Compliance: 100%",
    "status": "Valid"
  },
  {
    "id": "TRN-2026-LATEST-021",
    "employeeName": "Radio Operator Certificate",
    "employeeId": "4 Required / 4 Valid / 0 Expired",
    "site": "ZHONGYOUHAI-16",
    "department": "Training Compliance",
    "type": "Mandatory / Certification",
    "trainer": "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
    "date": "2026-06-03",
    "expiryDate": "Not Required: 132; Compliance: 100%",
    "status": "Valid"
  },
  {
    "id": "TRN-2026-LATEST-022",
    "employeeName": "MIGAS",
    "employeeId": "61 Required / 61 Valid / 0 Expired",
    "site": "ZHONGYOUHAI-16",
    "department": "Training Compliance",
    "type": "Mandatory / Certification",
    "trainer": "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
    "date": "2026-06-03",
    "expiryDate": "Not Required: 132; Compliance: 100%",
    "status": "Valid"
  },
  {
    "id": "TRN-2026-LATEST-023",
    "employeeName": "Advanced Trauma Life Support (ATLS)",
    "employeeId": "2 Required / 2 Valid / 0 Expired",
    "site": "ZHONGYOUHAI-16",
    "department": "Training Compliance",
    "type": "Mandatory / Certification",
    "trainer": "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
    "date": "2026-06-03",
    "expiryDate": "Not Required: 0; Compliance: 100%",
    "status": "Valid"
  },
  {
    "id": "TRN-2026-LATEST-024",
    "employeeName": "Advance Cardiac Life Support",
    "employeeId": "1 Required / 1 Valid / 0 Expired",
    "site": "ZHONGYOUHAI-16",
    "department": "Training Compliance",
    "type": "Mandatory / Certification",
    "trainer": "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
    "date": "2026-06-03",
    "expiryDate": "Not Required: 0; Compliance: 100%",
    "status": "Valid"
  },
  {
    "id": "TRN-2026-LATEST-025",
    "employeeName": "Food Handlers",
    "employeeId": "10 Required / 10 Valid / 0 Expired",
    "site": "ZHONGYOUHAI-16",
    "department": "Training Compliance",
    "type": "Mandatory / Certification",
    "trainer": "TRAINING_MATRIX_ZYH-16 2026_05-30_GDAP_UPDATED.xlsx",
    "date": "2026-06-03",
    "expiryDate": "Not Required: 0; Compliance: 100%",
    "status": "Valid"
  }
];

const waste = [];

const incTypes = ["Slip/Trip/Fall", "Struck By Object", "Equipment Failure", "Chemical Spill", "Electrical", "Vehicle", "Manual Handling", "Fire/Smoke"];

const achievement = (target, realization, inverse = false) => {
  if (target === 0) return realization === 0 ? 100 : 0;
  const raw = inverse ? ((target - realization) / target) * 100 : (realization / target) * 100;
  return Math.max(0, Math.round(raw));
};

const leadingIndicators = [
  {
    "no": 1,
    "indicator": "Rig Manager Visit",
    "target": 1,
    "realization": 1,
    "achievement": 100,
    "frequency": "1x / Month",
    "status": "Completed",
    "remarks": "April 2026 realization: 1."
  },
  {
    "no": 2,
    "indicator": "HSSE Manager Visit",
    "target": 1,
    "realization": 1,
    "achievement": 100,
    "frequency": "1x / Month",
    "status": "Completed",
    "remarks": "April 2026 Marvin Tenda visit recorded 30 Apr - 5 May."
  },
  {
    "no": 3,
    "indicator": "Socialization HSSE Policy",
    "target": 1,
    "realization": 1,
    "achievement": 100,
    "frequency": "Yearly",
    "status": "Completed",
    "remarks": "April 2026 realization: 1."
  },
  {
    "no": 4,
    "indicator": "Pre-Job Meeting / Toolbox Meeting",
    "target": 302,
    "realization": 302,
    "achievement": 100,
    "frequency": "Every shift",
    "status": "Completed",
    "remarks": "April 2026 realization: 302."
  },
  {
    "no": 5,
    "indicator": "Safety Talks",
    "target": 4,
    "realization": 4,
    "achievement": 100,
    "frequency": "Weekly",
    "status": "Completed",
    "remarks": "April 2026 realization: 4."
  },
  {
    "no": 6,
    "indicator": "Speak Up",
    "target": 30,
    "realization": 30,
    "achievement": 100,
    "frequency": "Daily",
    "status": "Completed",
    "remarks": "April 2026 realization: 30."
  },
  {
    "no": 7,
    "indicator": "Perwira Safety",
    "target": 4,
    "realization": 4,
    "achievement": 100,
    "frequency": "Weekly",
    "status": "Completed",
    "remarks": "April 2026 realization: 4."
  },
  {
    "no": 8,
    "indicator": "View & Review",
    "target": 4,
    "realization": 4,
    "achievement": 100,
    "frequency": "Weekly",
    "status": "Completed",
    "remarks": "April 2026 realization: 4."
  },
  {
    "no": 9,
    "indicator": "Safety Stand Down",
    "target": 5,
    "realization": 5,
    "achievement": 100,
    "frequency": "Quarterly",
    "status": "Completed",
    "remarks": "April 2026 realization: 5."
  },
  {
    "no": 10,
    "indicator": "HSE Coordination Meeting / Level III",
    "target": 2,
    "realization": 2,
    "achievement": 100,
    "frequency": "Monthly",
    "status": "Completed",
    "remarks": "April 2026 realization: 2 biweekly."
  },
  {
    "no": 11,
    "indicator": "HSE Meeting Level IV",
    "target": 4,
    "realization": 4,
    "achievement": 100,
    "frequency": "Weekly",
    "status": "Completed",
    "remarks": "April 2026 realization: 4."
  },
  {
    "no": 12,
    "indicator": "HOC Card / Safety Intervention Program",
    "target": 3381,
    "realization": 3381,
    "achievement": 100,
    "frequency": "1 card per person/day",
    "status": "Completed",
    "remarks": "April 2026 realization: 3,381."
  },
  {
    "no": 13,
    "indicator": "HSSE Performance Reporting",
    "target": 1,
    "realization": 1,
    "achievement": 100,
    "frequency": "Monthly",
    "status": "Completed",
    "remarks": "April 2026 report received."
  },
  {
    "no": 14,
    "indicator": "Safety Induction",
    "target": 35,
    "realization": 35,
    "achievement": 100,
    "frequency": "Every first entry",
    "status": "Completed",
    "remarks": "April 2026 realization: 35."
  },
  {
    "no": 15,
    "indicator": "Daily Inspection Crane",
    "target": 30,
    "realization": 30,
    "achievement": 100,
    "frequency": "Daily",
    "status": "Completed",
    "remarks": "April 2026 realization: 30."
  },
  {
    "no": 16,
    "indicator": "Weekly Inspection Crane",
    "target": 4,
    "realization": 4,
    "achievement": 100,
    "frequency": "Weekly",
    "status": "Completed",
    "remarks": "April 2026 realization: 4."
  },
  {
    "no": 17,
    "indicator": "Fire Pump Inspection & Testing",
    "target": 4,
    "realization": 4,
    "achievement": 100,
    "frequency": "Weekly",
    "status": "Completed",
    "remarks": "April 2026 realization: 4."
  },
  {
    "no": 18,
    "indicator": "Hand & Portable Power Tools Checklist",
    "target": 4,
    "realization": 4,
    "achievement": 100,
    "frequency": "Weekly",
    "status": "Completed",
    "remarks": "April 2026 realization: 4."
  },
  {
    "no": 19,
    "indicator": "Waste Transfer Note",
    "target": 4,
    "realization": 4,
    "achievement": 100,
    "frequency": "Weekly",
    "status": "Completed",
    "remarks": "April 2026 realization: 4."
  },
  {
    "no": 20,
    "indicator": "Workplace Inspection",
    "target": 1,
    "realization": 1,
    "achievement": 100,
    "frequency": "Monthly",
    "status": "Completed",
    "remarks": "April 2026 realization: 1."
  },
  {
    "no": 21,
    "indicator": "Housekeeping, Proper Storage & Used Proper Tool",
    "target": 1,
    "realization": 1,
    "achievement": 100,
    "frequency": "Monthly",
    "status": "Completed",
    "remarks": "April housekeeping completed: 14 items scored 100%."
  },
  {
    "no": 22,
    "indicator": "Safety Equipment and Maintenance Inspection",
    "target": 1,
    "realization": 1,
    "achievement": 100,
    "frequency": "Monthly",
    "status": "Completed",
    "remarks": "April 2026 realization: 1."
  },
  {
    "no": 23,
    "indicator": "PPE Inspection",
    "target": 1,
    "realization": 1,
    "achievement": 100,
    "frequency": "Monthly",
    "status": "Completed",
    "remarks": "April 2026 realization: 1."
  },
  {
    "no": 24,
    "indicator": "Lifting Gear Inspection",
    "target": 1,
    "realization": 1,
    "achievement": 100,
    "frequency": "Monthly",
    "status": "Completed",
    "remarks": "April 2026 realization: 1."
  },
  {
    "no": 25,
    "indicator": "Rig Inspection",
    "target": 4,
    "realization": 4,
    "achievement": 100,
    "frequency": "Weekly",
    "status": "Completed",
    "remarks": "April 2026 realization: 4."
  },
  {
    "no": 26,
    "indicator": "SECE Inspection",
    "target": 1,
    "realization": 1,
    "achievement": 100,
    "frequency": "Monthly",
    "status": "Completed",
    "remarks": "April SECE inspection completed."
  },
  {
    "no": 27,
    "indicator": "Preventive Maintenance System",
    "target": 1,
    "realization": 1,
    "achievement": 100,
    "frequency": "Monthly",
    "status": "Documented",
    "remarks": "April PMS file received; exact scanned table counts not injected."
  },
  {
    "no": 28,
    "indicator": "Hygiene Inspection at Galley",
    "target": 4,
    "realization": 4,
    "achievement": 100,
    "frequency": "Weekly",
    "status": "Completed",
    "remarks": "April 2026 realization: 4."
  },
  {
    "no": 29,
    "indicator": "Pest Control",
    "target": 2,
    "realization": 2,
    "achievement": 100,
    "frequency": "Monthly",
    "status": "Completed",
    "remarks": "April 2026 realization: 2."
  },
  {
    "no": 30,
    "indicator": "Emergency Drill",
    "target": 5,
    "realization": 5,
    "achievement": 100,
    "frequency": "Weekly",
    "status": "Completed",
    "remarks": "Fire Drill 8 Apr, Abandon Drill 8 Apr, Medical Emergency 8 Apr, Abandon Drill 21 Apr."
  },
  {
    "no": 31,
    "indicator": "HSSE Award",
    "target": 4,
    "realization": 4,
    "achievement": 100,
    "frequency": "Monthly",
    "status": "Completed",
    "remarks": "April evidence includes Best Perwira Safety: Dava Hariatmaja and Best CeRMAT: Muhammad Riky."
  },
  {
    "no": 32,
    "indicator": "Investigation Incident",
    "target": 3,
    "realization": 3,
    "achievement": 100,
    "frequency": "Monthly",
    "status": "Recorded",
    "remarks": "April leading indicator shows investigation incident realization: 3. No fake incident case rows added."
  },
  {
    "no": 33,
    "indicator": "Follow up Audit / Inspection",
    "target": 1,
    "realization": 1,
    "achievement": 100,
    "frequency": "Monthly",
    "status": "Completed",
    "remarks": "April 2026 realization: 1."
  },
  {
    "no": 34,
    "indicator": "Audit CSMS PB - Work in Progress",
    "target": 1,
    "realization": 1,
    "achievement": 100,
    "frequency": "March/April 2026",
    "status": "On Site",
    "remarks": "CSMS PB shown as on-site."
  }
];

const laggingIndicators = [
  {
    "no": 1,
    "indicator": "Number of Nearmiss",
    "target": 0,
    "realization": 0,
    "achievement": 100,
    "status": "No Case",
    "remarks": "April 2026 reported zero."
  },
  {
    "no": 2,
    "indicator": "Number of First Aid",
    "target": 0,
    "realization": 0,
    "achievement": 100,
    "status": "No Case",
    "remarks": "April 2026 reported zero."
  },
  {
    "no": 3,
    "indicator": "Fatality",
    "target": 0,
    "realization": 0,
    "achievement": 100,
    "status": "No Case",
    "remarks": "April 2026 reported zero."
  },
  {
    "no": 4,
    "indicator": "Lost Time Incident (LTI)",
    "target": 0,
    "realization": 0,
    "achievement": 100,
    "status": "No Case",
    "remarks": "April 2026 reported zero."
  },
  {
    "no": 5,
    "indicator": "Restricted Work Day Case (RWDC)",
    "target": 0,
    "realization": 0,
    "achievement": 100,
    "status": "No Case",
    "remarks": "April 2026 reported zero."
  },
  {
    "no": 6,
    "indicator": "Medical Treatment Case (MTC)",
    "target": 0,
    "realization": 0,
    "achievement": 100,
    "status": "No Case",
    "remarks": "April 2026 reported zero."
  },
  {
    "no": 7,
    "indicator": "Oil Spill",
    "target": 0,
    "realization": 0,
    "achievement": 100,
    "status": "No Case",
    "remarks": "April 2026 reported zero."
  },
  {
    "no": 8,
    "indicator": "Hydrocarbon Release",
    "target": 0,
    "realization": 0,
    "achievement": 100,
    "status": "No Case",
    "remarks": "April 2026 reported zero."
  },
  {
    "no": 9,
    "indicator": "Non-Compliance Case",
    "target": 0,
    "realization": 0,
    "achievement": 100,
    "status": "No Case",
    "remarks": "April 2026 reported zero."
  },
  {
    "no": 10,
    "indicator": "Fire / Explosion",
    "target": 0,
    "realization": 0,
    "achievement": 100,
    "status": "No Case",
    "remarks": "April 2026 reported zero."
  },
  {
    "no": 11,
    "indicator": "Property Damage",
    "target": 0,
    "realization": 0,
    "achievement": 100,
    "status": "No Case",
    "remarks": "April 2026 reported zero."
  }
];
const inspectionSchedule = [
  {
    "item": "Internal Monthly Report - January 2026",
    "frequency": "Monthly",
    "target": 1,
    "realization": "Monthly internal report received",
    "compliance": 100,
    "status": "Completed",
    "remarks": "January evidence: 301 days without LTI, 176 Stop Job, 3,945 HOC, 507,420 man-hours, zero incident/LTI/fatality."
  },
  {
    "item": "Internal Monthly Report - February 2026",
    "frequency": "Monthly",
    "target": 1,
    "realization": "Monthly internal report received",
    "compliance": 100,
    "status": "Completed",
    "remarks": "February evidence: 329 days without LTI, 316 Stop Job, 6,842 HOC, 587,988 man-hours, zero incident/LTI/fatality."
  },
  {
    "item": "Internal Monthly Report - March 2026",
    "frequency": "Monthly",
    "target": 1,
    "realization": "Monthly internal report received",
    "compliance": 100,
    "status": "Completed",
    "remarks": "March evidence: 360 days without LTI, 547 Stop Job, 10,633 HOC, zero incident/LTI/fatality, CSR and Re-CSMS audit recorded."
  },
  {
    "item": "Annual Drill Schedule 2026",
    "frequency": "Annual Plan",
    "target": 112,
    "realization": "112 planned drills",
    "compliance": 100,
    "status": "Documented",
    "remarks": "Annual drill schedule recorded for Fire/Emergency, Abandonment, H2S, Communication, MOB, Lifeboat, Oil Spill, Medical Emergency, Security and other drills."
  },
  {
    "item": "May Weekly Hazard Hunt Schedule",
    "frequency": "Weekly",
    "target": 5,
    "realization": "5 planned weekly hazard hunts",
    "compliance": 100,
    "status": "Planned",
    "remarks": "May schedule: 1, 8, 15, 22, 29 May 2026; areas include Warehouse, Mechanical Workshop, Compressor Room, Mud Pump/Mud Pit, Engine Room/Transformer Room."
  },
  {
    "item": "Housekeeping & Proper Tool Audit",
    "frequency": "Monthly",
    "target": 14,
    "realization": "14 visible audit items",
    "compliance": 100,
    "status": "Completed",
    "remarks": "April 2026: all 14 items scored 100%."
  },
  {
    "item": "ESD Matrix Inspection",
    "frequency": "Yearly / Monthly Loop Check",
    "target": 10,
    "realization": "10 ESD / F&G items inspected",
    "compliance": 100,
    "status": "Completed",
    "remarks": "April 2026 ESD matrix: all items average 10/10."
  },
  {
    "item": "SECE Critical Equipment Inspection",
    "frequency": "Monthly",
    "target": 11,
    "realization": "11 SECE elements recorded",
    "compliance": 100,
    "status": "Completed",
    "remarks": "April 2026 SECE: visible elements marked Good / 100%."
  },
  {
    "item": "Preventive Maintenance System",
    "frequency": "Monthly",
    "target": 1,
    "realization": "PMS April source file received",
    "compliance": 100,
    "status": "Documented",
    "remarks": "PMS -ZYH16-April-2026.pdf received. Exact counts not injected due scanned PDF extraction risk."
  },
  {
    "item": "Emergency Drill",
    "frequency": "Weekly",
    "target": 5,
    "realization": "5 drills",
    "compliance": 100,
    "status": "Completed",
    "remarks": "April emergency drill realization: 5."
  },
  {
    "item": "Management Visit Follow-up",
    "frequency": "Monthly",
    "target": 7,
    "realization": "7 actions/follow-ups",
    "compliance": 100,
    "status": "Closed",
    "remarks": "April management visit and HSE visit actions recorded."
  },
  {
    "item": "CSMS Audit",
    "frequency": "March 2026",
    "target": 1,
    "realization": "1 on-site CSMS PB / re-audit action",
    "compliance": 100,
    "status": "Open",
    "remarks": "CSMS re-audit action recorded from MOM HSE Visit."
  }
];
const emergencyDrills = [
  {
    "id": "DRILL-2026-JAN-001",
    "drillType": "Fire and Abandon Ship Drill",
    "type": "Fire / Abandon Ship",
    "name": "Fire and Abandon Ship Drill",
    "date": "2026-01-21",
    "dateMonth": "21 Jan 2026",
    "site": "ZHONGYOUHAI-16",
    "target": 1,
    "realization": 1,
    "participants": 146,
    "status": "Completed",
    "remarks": "Emergency drill reporting form recorded."
  },
  {
    "id": "DRILL-2026-MAR-001",
    "drillType": "Abandon Drill",
    "type": "Abandon Drill",
    "name": "Abandon Drill",
    "date": "2026-03-03",
    "dateMonth": "3 Mar 2026",
    "site": "ZHONGYOUHAI-16",
    "target": 1,
    "realization": 1,
    "status": "Completed",
    "remarks": "March emergency drill record."
  },
  {
    "id": "DRILL-2026-MAR-002",
    "drillType": "Kick Drill",
    "type": "Kick Drill",
    "name": "Kick Drill",
    "date": "2026-03-18",
    "dateMonth": "18 Mar 2026",
    "site": "ZHONGYOUHAI-16",
    "target": 1,
    "realization": 1,
    "status": "Completed",
    "remarks": "March emergency drill record."
  },
  {
    "id": "DRILL-2026-MAR-003",
    "drillType": "Fire & Abandon Drill",
    "type": "Fire / Abandon Drill",
    "name": "Fire & Abandon Drill",
    "date": "2026-03-25",
    "dateMonth": "25 Mar 2026",
    "site": "ZHONGYOUHAI-16",
    "target": 1,
    "realization": 1,
    "status": "Completed",
    "remarks": "March emergency drill record."
  },
  {
    "id": "DRILL-2026-APR-001",
    "drillType": "Fire Drill",
    "type": "Fire Drill",
    "name": "Fire Drill",
    "date": "2026-04-08",
    "dateMonth": "8 Apr 2026",
    "site": "ZHONGYOUHAI-16",
    "target": 1,
    "realization": 1,
    "status": "Completed",
    "remarks": "April emergency drill record."
  },
  {
    "id": "DRILL-2026-APR-002",
    "drillType": "Abandon Drill",
    "type": "Abandon Drill",
    "name": "Abandon Drill",
    "date": "2026-04-08",
    "dateMonth": "8 Apr 2026",
    "site": "ZHONGYOUHAI-16",
    "target": 1,
    "realization": 1,
    "status": "Completed",
    "remarks": "April emergency drill record."
  },
  {
    "id": "DRILL-2026-APR-003",
    "drillType": "Medical Emergency",
    "type": "Medical Emergency",
    "name": "Medical Emergency",
    "date": "2026-04-08",
    "dateMonth": "8 Apr 2026",
    "site": "ZHONGYOUHAI-16",
    "target": 1,
    "realization": 1,
    "status": "Completed",
    "remarks": "April emergency drill record."
  },
  {
    "id": "DRILL-2026-APR-004",
    "drillType": "General Alarm / Mustering",
    "type": "General Alarm",
    "name": "General Alarm / Mustering",
    "date": "2026-04-08",
    "dateMonth": "8 Apr 2026",
    "site": "ZHONGYOUHAI-16",
    "target": 1,
    "realization": 1,
    "status": "Completed",
    "remarks": "April emergency drill record."
  },
  {
    "id": "DRILL-2026-APR-005",
    "drillType": "Abandon Drill",
    "type": "Abandon Drill",
    "name": "Abandon Drill",
    "date": "2026-04-21",
    "dateMonth": "21 Apr 2026",
    "site": "ZHONGYOUHAI-16",
    "target": 1,
    "realization": 1,
    "status": "Completed",
    "remarks": "April emergency drill record."
  }
];

const auditFollowUps = [
  {
    "item": "Helideck Safety",
    "targetDue": "2026-02-03",
    "realization": "Closed",
    "status": "Closed",
    "remarks": "One helideck perimeter light earthing cable found disconnected. Action: Reinstate and verify proper earthing for helideck boundary lights and conduct functional checks."
  },
  {
    "item": "Dropped Object Prevention",
    "targetDue": "2026-02-03",
    "realization": "Closed",
    "status": "Closed",
    "remarks": "Anti-drop safety net for light fittings on accommodation roof not installed as per standard. Action: Install or rectify anti-drop safety nets for light fittings in accordance with applicable standards."
  },
  {
    "item": "Fire Safety",
    "targetDue": "2026-02-03",
    "realization": "Pending closeout",
    "status": "Open",
    "remarks": "One fire hydrant blind cap safety chain found broken on main deck. Action: Replace damaged fire hydrant blind cap safety chain and inspect similar fittings for integrity."
  },
  {
    "item": "Housekeeping",
    "targetDue": "2026-02-03",
    "realization": "Closed",
    "status": "Closed",
    "remarks": "Unnecessary materials observed in emergency generator room. Action: Remove all non-essential items from emergency generator room and reinforce housekeeping controls."
  },
  {
    "item": "Certification / Inspection",
    "targetDue": "2026-02-03",
    "realization": "Pending closeout",
    "status": "Open",
    "remarks": "Man-riding basket inspection approaching expiry date. Action: Arrange inspection and re-certification of man-riding basket before inspection expiry date."
  },
  {
    "id": "AUD-FU-2026-MAR-001",
    "date": "2026-03-10",
    "site": "ZHONGYOUHAI-16",
    "auditRef": "AUD-2026-MAR-HSE-VISIT",
    "finding": "Conduct a CSMS re-audit.",
    "responsible": "HSE",
    "dueDate": "2026-03-31",
    "status": "Open",
    "priority": "High",
    "remarks": "MOM HSE Visit 7-10 March 2026"
  },
  {
    "id": "AUD-FU-2026-MAR-002",
    "date": "2026-03-10",
    "site": "ZHONGYOUHAI-16",
    "auditRef": "AUD-2026-MAR-HSE-VISIT",
    "finding": "Monitor all activities on ZYH-16 Rig, including main deck, cantilever, and rig floor, to ensure operations proceed smoothly, safely, and securely.",
    "responsible": "HSE",
    "dueDate": "2026-03-31",
    "status": "Open",
    "priority": "Medium",
    "remarks": "MOM HSE Visit 7-10 March 2026"
  },
  {
    "id": "AUD-FU-2026-APR-001",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "auditRef": "AUD-2026-APR-MGT-VISIT",
    "finding": "Some materials in storage room stacked too tightly; reorganize storage room for safe access and handling.",
    "responsible": "Material man",
    "dueDate": "2026-04-30",
    "status": "Closed",
    "priority": "Medium",
    "remarks": "April 2026 MOM / Management Visit"
  },
  {
    "id": "AUD-FU-2026-APR-002",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "auditRef": "AUD-2026-APR-MGT-VISIT",
    "finding": "Warehouse labeling not consistent; standardize labeling and update all labels.",
    "responsible": "Material man",
    "dueDate": "2026-04-30",
    "status": "Closed",
    "priority": "Medium",
    "remarks": "April 2026 MOM / Management Visit"
  },
  {
    "id": "AUD-FU-2026-APR-003",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "auditRef": "AUD-2026-APR-MGT-VISIT",
    "finding": "Fire hose cabinet needs checking for complete equipment and good condition.",
    "responsible": "BM",
    "dueDate": "2026-04-30",
    "status": "Closed",
    "priority": "Medium",
    "remarks": "April 2026 MOM / Management Visit"
  },
  {
    "id": "AUD-FU-2026-APR-004",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "auditRef": "AUD-2026-APR-MGT-VISIT",
    "finding": "Risk awareness during routine work needs strengthening through toolbox talks and supervision.",
    "responsible": "Toolpusher / Driller / BM",
    "dueDate": "2026-04-30",
    "status": "Closed",
    "priority": "Medium",
    "remarks": "April 2026 MOM / Management Visit"
  },
  {
    "id": "AUD-FU-2026-APR-005",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "auditRef": "AUD-2026-APR-MGT-VISIT",
    "finding": "Communication and command during towing operations need clearer roles, signals and command lines.",
    "responsible": "All crew",
    "dueDate": "2026-04-30",
    "status": "Closed",
    "priority": "Medium",
    "remarks": "April 2026 MOM / Management Visit"
  },
  {
    "id": "AUD-FU-2026-APR-006",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "auditRef": "AUD-2026-APR-MGT-VISIT",
    "finding": "Safety culture improved and MCU personnel database established for health status tracking.",
    "responsible": "HSE",
    "dueDate": "2026-04-30",
    "status": "Closed",
    "priority": "Medium",
    "remarks": "April 2026 MOM / Management Visit"
  },
  {
    "id": "AUD-FU-2026-APR-007",
    "date": "2026-04-30",
    "site": "ZHONGYOUHAI-16",
    "auditRef": "AUD-2026-APR-MGT-VISIT",
    "finding": "Pre SIMOPS Meeting SNB WPN-3 conducted / recorded.",
    "responsible": "HSE",
    "dueDate": "2026-04-30",
    "status": "Closed",
    "priority": "Medium",
    "remarks": "April 2026 MOM / Management Visit"
  }
];

export const SAMPLE = {
  schemaVersion: 27,
  sites: SITE_NAMES,
  departments: DEPARTMENTS,
  months: MONTHS,
  kpiRows: KPI_ROWS,
  monthlyKPI: generateMarvinKPI(),
  leadingIndicators,
  laggingIndicators,
  inspectionSchedule,
  emergencyDrills,
  auditFollowUps,
  incidents,
  inspections,
  actions,
  ptws,
  trainingSummary,
  trainings,
  observations,
  ncrs,
  audits,
  waste,
  legalRefs: LEGAL_REFS,
  settings: {
    company: "Personal HSSE Reporting System",
    systemTitle: "HSSE Command & Reporting System",
    client: "Marvin HSSE Dashboard",
    systemType: "Leading & Lagging Indicator Performance Dashboard",
    sites: SITE_OBJECTS,
    departments: DEPARTMENTS,
    contractors: ["Alpha Co.", "Beta Industrial", "Gamma Eng.", "Delta Ltd.", "Operations Team", "Maintenance Team", "Facilities Team"],
    inspectionTypes: ["Equipment", "PPE", "Workplace", "Fire Safety", "Electrical", "Scaffolding", "Lifting Gear"],
    incidentTypes: incTypes,
    obsCategories: ["Housekeeping", "PPE", "Behavior", "Equipment", "Procedure"],
    observationSubcategories: ["General"],
    sorCategories: ["Safe", "Unsafe", "Environmental", "Quality"],
    ncrCategories: ["Quality", "Process", "Documentation", "Safety", "Environmental"],
    actionOwners: ["HSE Manager", "Operations Lead", "Maintenance Supervisor", "QA/QC Lead", "Logistics Lead", "Facilities Lead", "Training Lead"],
    mandateRecipients: ["HSE Manager", "Operations Lead", "Maintenance Supervisor"],
    trainingTypes: ["Inhouse", "Induction", "Specific", "External"],
    ptwTypes: ["Hot Work", "Confined Space", "Working at Height", "Electrical", "Excavation", "Lifting"],
    auditTypes: ["Internal", "External"],
    riskLevels: ["Low", "Medium", "High", "Critical"],
    statusValues: ["Open", "In Progress", "Closed", "Overdue", "Approved", "Expired", "Rejected", "Valid"],
    regions: REGIONS,
    users: [{ id: 1, name: "HSE Administrator", role: "HSE Manager" }],
    targets: { incidentTarget: 0, trainingCompliance: 95, obsClosure: 90, ncrClosure: 85, sorClosure: 90 },
    themeColor: "#082B4D",
    address: "Personal HSSE reporting workspace",
    contactPerson: "Marvin",
    email: "marvin.hsse@example.com",
    phone: "+000 000 0000",
    reportHeader: "HSSE Command & Reporting System - Marvin HSSE Dashboard",
    reportFooter: "Frontend report generated for Marvin's HSSE KPI review.",
  },
};

export { SITE_NAMES as SITES, SITE_OBJECTS, DEPARTMENTS, MONTHS, KPI_ROWS, REGIONS };
